import { Component, OnInit, ViewChild } from "@angular/core";
import { ChartType, ChartOptions, ChartDataSets } from "chart.js";
import { FormGroup, FormControl } from "@angular/forms";
import { Label } from "ng2-charts";

import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { EMRService } from "./EMR.service";
import { VisitDateModel } from "app/table-list/Models/visitdate.model";
import { NavigationStart, Router } from "@angular/router";
import { DatePipe, Location } from "@angular/common";
import { MatAccordion } from "@angular/material/expansion";
import { FitnessCheckupDetail } from "./EMRModels/fitness-checkup-detail.model";
import { AuthService } from "app/auth/auth.service";
import { BranchMatserService } from "app/masters/branch-matser.service";
import { PatientdocsComponent } from "app/table-list/patientdocs/patientdocs.component";
import { BehaviorSubject, Observable, Subject, Subscription, forkJoin, of } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";
import { InhouseSurgeriesComponent } from "./Doctor/inhouse-surgeries/inhouse-surgeries.component";
import { DoctorOtherInfoComponent } from "./Doctor/doctor-other-info/doctor-other-info.component";
import { PastHistoryComponent } from "./History/past-history/past-history.component";
import { SurgicalHistoryComponent } from "./History/surgical-history/surgical-history.component";
import { DrugAllergyComponent } from "./History/drug-allergy/drug-allergy.component";
import { HistoryOtherInfoComponent } from "./History/history-other-info/history-other-info.component";
import { IOPComponent } from "./PrimaryExamination/IOP/IOP.component";
import { VisionComponent } from "./PrimaryExamination/Vision/Vision.component";
import { Glass_prescriptionComponent } from "./PrimaryExamination/glass_prescription/glass_prescription.component";
import * as moment from "moment";
import { Present_ComplaintsComponent } from "./PrimaryExamination/Present_Complaints/Present_Complaints.component";
import { MedicineComponent } from "./Doctor/medicine/medicine.component";
import { DoctorDiagnosisComponent } from "./Doctor/doctor-diagnosis/doctor-diagnosis.component";
import { InvestigationComponent } from "./Doctor/investigation/investigation.component";
import { FindingExaminationComponent } from "./Doctor/finding-examination/finding-examination.component";
import { SurgeryComponent } from "./Doctor/surgery/surgery.component";
import { SiteloaderComponent } from "app/auth/siteloader/siteloader.component";
import { PatientMoveDialogComponent } from "app/dashboard/patient-move-dialog/patient-move-dialog.component";
import { WaitingReasonComponent } from "app/dashboard/WaitingReason/WaitingReason.component";
import { DoctorReviewComponent } from "./Doctor/doctor-review/doctor-review.component";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { callStatusModel } from "./HistoryModels/callStausModel";
@Component({
  selector: "app-EMR",
  templateUrl: "./EMR.component.html",
  styleUrls: ["./EMR.component.scss"],
})
export class EMRComponent implements OnInit {
  @ViewChild("closebutton") closebutton;
  destroyemr$: Subject<boolean> = new Subject<boolean>();
  destroymedicine$: Subject<boolean> = new Subject<boolean>();
  destroydia$: Subject<boolean> = new Subject<boolean>();
  destroypresent$: Subject<boolean> = new Subject<boolean>();
  destroypast$: Subject<boolean> = new Subject<boolean>();
  destroysugical$: Subject<boolean> = new Subject<boolean>();
  destroydrug$: Subject<boolean> = new Subject<boolean>();
  destroyfinding$: Subject<boolean> = new Subject<boolean>();
  destroysurgery$: Subject<boolean> = new Subject<boolean>();
  destroyglass$: Subject<boolean> = new Subject<boolean>();
  destroyvision$: Subject<boolean> = new Subject<boolean>();
  destroyreview$: Subject<boolean> = new Subject<boolean>();
  private destroyinves$: Subject<boolean> = new Subject<boolean>();
  disablebtn: boolean = true;
  past_histroyApicall: () => void;
  surgi_histroyApicall: () => void;
  durgg_histroyApicall: () => void;
  complaint_dataApicall: () => void;
  finding_dataApicall: () => void;

  handleFunction(func: () => void) {
    this.past_histroyApicall = func;
  }

  surgicalFunction(func: () => void) {
    this.surgi_histroyApicall = func;
  }

  drugFunction(func: () => void) {
    this.durgg_histroyApicall = func;
  }

  compaintFunction(func: () => void) {
    this.complaint_dataApicall = func;
  }

  findingFunction(func: () => void) {
    this.finding_dataApicall = func;
  }

  private past_history: any = [];
  private sergi_history: any = [];
  private drug_data: any = [];
  isReadonly = false;
  private ischecked: boolean = false;
  private selectedField: string = "";
  private selectedHeader: string = "";
  private advisedName: string = "";
  private boxDisabled: string = "Add";
  private medicinedata: any = [];
  private drdaignosisdata: any = [];
  private investigationdata: any = [];
  private examination_data: any = [];
  private examdetailArray: any = [];
  private surgery_data: any = [];
  private inhouse_data: any = [];
  private datalist: any = [];
  private QMYN: boolean = false;
  apiCallTrigger: boolean = false;
  filterQuery: string = "";
  filteredDataa: any = [];






  private callstausModelobj: callStatusModel = {};
  //...for the popup true/false value...//
  showmodeal: boolean;
  passdata(data) {
    this.showmodeal = data;
    // console.log(data, 'called true value')
  }

  @ViewChild(MatAccordion) accordion: MatAccordion;

  @ViewChild("tabGroup", { static: false }) tabGroup;

  apicount = 0;
  xpandStatus = 0;
  private FitnessCheckupData: FitnessCheckupDetail = {};
  //for emr header
  private ApprovalStatuslist: any;
  private pageload: boolean = false;
  private selectReportValue: string = "Prescription";
  private displayedColumns: string[] = [
    "branchCode",
    "Visitdate",
    "drNameShort",
    "ar",
    "op",
  ];
  private dataSource = new MatTableDataSource<VisitDateModel>();

  private selectedIndex: number = 1;
  private showspinner: any;

  private emrmini = true;
  private isemrButton: boolean = true;

  private currentSection: any = "section1";
  private diagnosislist: any = [];
  private investigationDetaillist: any = [];
  private prescriptionDetaillist: any = [];
  private optoList: any = [];
  private otsurgrylist: any = [];
  private iopdetailslist: any = [];
  private groupedFindingData: any = [];
  private popupcontrolindex = -1;
  private moveUrl: String = "";
  private consultationSection: boolean = true;
  private overviewSection: boolean = false;
  private navigationSubscription!: Subscription;
  private emrDoctorCtrl: FormControl;
  private filteredDoctorArray: Observable<any[]>;
  private newdrworkupid: any;
  constructor(
    private http: HttpClient,
    private opdvisitService: OpdVisitService,
    private dashboardService: DashboardService,
    private branchMatserService: BranchMatserService,
    private dialog: MatDialog,
    private _location: Location,
    private emrservice: EMRService,
    private authService: AuthService,
    private router: Router,
    private datepipe: DatePipe
  ) {
    this.emrservice.getHistoryStatus(this.opdvisitService.visitid);
    // this.authService.getServertime();
    this.getSite();
    this.checkNavigator(0);
  }

  /** AI Scribe (full consultation): publish the extracted workup. All doctor
   *  sections are already mounted and subscribed, so they fill in place — no
   *  navigation, no tab-sweep (both caused flicker). */
  applyAiWorkup(sections: any): void {
    this.emrservice.applyAiWorkup(sections);
  }

  private isNavigatingToEMR = false;
  checkNavigator(type: any) {

    if (type == 0) {
      this.popupcontrolindex = 0;
      this.navigationSubscription = this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (
            this.emrservice.enabledisablebtn == false ||
            this.emrservice.enabledisablebtnInv == false ||
            this.emrservice.enabledisablebtnDia == false ||
            this.emrservice.enabledisablebtnMed == false ||
            this.emrservice.enabledisablebtnSur == false ||
            this.emrservice.enabledisablebtnRev == false ||
            this.emrservice.enabledisablebtnInfo == false ||
            this.emrservice.enabledisablebtnpasthistory == false ||
            this.emrservice.enabledisablebtnsurhistory == false
          ) {
            const spliturl = event["url"].split("?");
            if (!this.isNavigatingToEMR) {
              this.isNavigatingToEMR = true; // prevent recursive calls
              this.router.navigate(["/layout/EMR"]).then(() => {
                this.isNavigatingToEMR = false; // reset flag after navigation completes
              });
              document.getElementById("DCtorSaveModel").style.display = "block";
              this.moveUrl = spliturl[0];
            }
          }
        }
      });
    } else {
      this.popupcontrolindex = type;
      if (
        this.emrservice.enabledisablebtn == false ||
        this.emrservice.enabledisablebtnInv == false ||
        this.emrservice.enabledisablebtnDia == false ||
        this.emrservice.enabledisablebtnMed == false ||
        this.emrservice.enabledisablebtnSur == false ||
        this.emrservice.enabledisablebtnRev == false ||
        this.emrservice.enabledisablebtnInfo == false ||
        this.emrservice.enabledisablebtnpasthistory == false ||
        this.emrservice.enabledisablebtnsurhistory == false
      ) {

        if (!this.isNavigatingToEMR) {
          this.isNavigatingToEMR = true; // prevent recursive calls
          this.router.navigate(["/layout/EMR"]).then(() => {
            this.isNavigatingToEMR = false; // reset flag after navigation completes
          });
          document.getElementById("DCtorSaveModel").style.display = "block";
          this.moveUrl = "/layout/dashboard";
        }
      } else {

        this.router.navigate(["/layout/dashboard"]);
      }
    }

  }
  NoSave() {
    if (this.emrservice.enabledisablebtnpasthistory == false) {
      this.scrollTo("section1");
    } else if (this.emrservice.enabledisablebtnsurhistory == false) {
      this.scrollTo("section2");
    } else if (this.emrservice.enabledisablebtn == false) {
      this.scrollTo("section19");
    } else if (this.emrservice.enabledisablebtnInv == false) {
      this.scrollTo("section20");
    } else if (this.emrservice.enabledisablebtnDia == false) {
      this.scrollTo("section21");
    } else if (this.emrservice.enabledisablebtnMed == false) {
      this.scrollTo("section22");
    } else if (this.emrservice.enabledisablebtnSur == false) {
      this.scrollTo("section23");
    } else if (this.emrservice.enabledisablebtnRev == false) {
      this.scrollTo("section24");
    } else if (this.emrservice.enabledisablebtnInfo == false) {
      this.scrollTo("section25");
    }
    this.popupcontrolindex = 0;
    document.getElementById("DCtorSaveModel").style.display = "none";
  }
  YesSave(type) {

    if (type == 0) {
      document.getElementById("DCtorSaveModel").style.display = "none";
      this.emrservice.enabledisablebtn = true;
      this.emrservice.enabledisablebtnInv = true;
      this.emrservice.enabledisablebtnDia = true;
      this.emrservice.enabledisablebtnMed = true;
      this.emrservice.enabledisablebtnSur = true;
      this.emrservice.enabledisablebtnRev = true;
      this.emrservice.enabledisablebtnInfo = true;
      this.emrservice.enabledisablebtnpasthistory = true;
      this.emrservice.enabledisablebtnsurhistory = true;
      if (this.moveUrl != "") {
        this.router.navigate([this.moveUrl]);
      }
    } else {
      this.checklastlocation(this.emrservice.visitid)

    }


    //this.elementRef.nativeElement.remove();
  }

  show = false;
  griddata = true;

  public btnSlider = false;

  emrButtontoggleSidebar() {
    if (this.emrmini) {
      // document.getElementById("emrbtnsection").style.width = "100%";
      document.getElementById("emrbtnsection").style.width = "80%";
      document.getElementById("emrbtnsection").style.padding = "5px";
      this.emrmini = false;
      this.isemrButton = false;
      this.btnSlider = true;
    } else {
      document.getElementById("emrbtnsection").style.width = "0px";
      document.getElementById("emrbtnsection").style.padding = "0";
      this.emrmini = true;
      this.isemrButton = true;
      this.btnSlider = false;
    }
  }

  groupnewArray: any;
  // mainmenuArray:any=[];
  ngOnInit() {
    this.authService.checkfirsttimeload = true;
    this.callstausModelobj = {};
    this.groupnewArray = [];
    var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "DoctorWorkupSingleSave");
    if (queueproty.length > 0) {
      this.emrservice.issingleDrworkupsave = queueproty[0]?.propertyValue == 'Y' ? true : false;
    }
    if (this.authService.Loggeduser.usertypeid == 6) {
      this.newdrworkupid = this.authService.Loggeduser.userid;
    } else {
      this.newdrworkupid = this.opdvisitService.DoctorIdEmr;
    }

    if (this.emrservice.webMenuPermission.length > 0) {

      const groupnewArray = this.emrservice.webMenuPermission.reduce(
        (r, { webMenuGroupName }) => {
          if (!r.some((o) => o.webMenuGroupName == webMenuGroupName)) {
            r.push({
              webMenuGroupName,
              groupItem: this.emrservice.webMenuPermission.filter(
                (v) => v.webMenuGroupName == webMenuGroupName
              ),
            });
          }
          return r;
        },
        []
      );

      const checkemr = groupnewArray.filter(
        (item) => item.webMenuGroupName.toLowerCase() == "emr"
      );
      if (checkemr.length > 0) {
        checkemr[0].groupItem.forEach((item: any) => {
          let findseqmenu = groupnewArray.filter(
            (data) => data.webMenuGroupName == item.webMenuName
          );
          this.groupnewArray = this.groupnewArray.concat(findseqmenu);
        });

        this.currentSection = this.groupnewArray[0].groupItem[0].webMenuLink;
      }
    } else {
      this.groupnewArray = [];
      //  this.mainmenuArray=[];
    }
    this.emrservice.transferArray = new BehaviorSubject<any>([]);
    this.emrservice.transferArrayMedicine = new BehaviorSubject<any>([]);
    this.emrservice.transferArraydiagonsis = new BehaviorSubject<any>([]);
    this.emrservice.transferArraysurgery = new BehaviorSubject<any>([]);
    this.emrservice.patientEMRdetail = [];
    this.emrservice.sitelist = [];
    this.emrservice.historyStatusresult = [];
    this.emrservice.localStorePriscription = [];
    this.emrservice.medinicationMainArray = [];
    this.emrservice.examdataNotavailable();
    this.emrservice.autoref = {};
    this.emrservice.opto = {};
    this.emrservice.optohelplist = {};
    this.emrservice.branchmansterObj = {};
    this.pageload = false;
    this.opdvisitService.callsepecificApi = "ALL";
    this.showspinner = false;
    console.log(this.dataSource.data);
    this.dataSource.data = [];
    // set selected background to initial stage
    //this.dashboardService.selectedRowIndex = -1;

    //  this.tabGroup.selectedIndex = this.emrservice.tabindex;

    // this.dataSource = new MatTableDataSource(this.opdvisitService.visitdates.slice().reverse());
    this.opdvisitService.get_old_photo();

    this.get_visit_dates(0);
    // this.getDiagnosisRegid(this.opdvisitService.patientdetails.pkRegId, 0, 0);
    //  this.emrservice.content.next('1');
    // check usertype and set tab as per that
    //this.tabGroup.selectedIndex = 2;
    this.FitnessCheckupData = {};

    this.getBranchDetail(this.authService.Loggeduser.branchid);
    // this.load_data_basedon_visitid();
    if (
      this.authService.masterdata.defaultView == "C" ||
      this.authService.masterdata.defaultView == null ||
      this.authService.masterdata.defaultView == ""
    ) {
      this.consultationSection = true;
      this.overviewSection = false;
    } else {
      this.overviewSection = true;
      this.consultationSection = false;
    }
    this.doctorControll();
  }
  getTitle(uId: number) {
    const uName = this.opdvisitService.doctors.filter(
      (item) => item.userId == uId
    );
    if (uName.length > 0) {
      return uName[0]?.userName;
    } else {
      return null;
    }
  }
  ngAfterViewInit(): void {
    //  this.cdr.detectChanges();
    // this.emrDoctorCtrl.patchValue(this.emrdoctorname);
  }

  getSite() {
    this.emrservice
      .getMasterSite()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data) => {
        this.emrservice.sitelist = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  // open_loader_Dialog(): void {

  //   const dialogRef = this.dialog.open(SiteloaderComponent, {
  //     width: '300px',
  //     panelClass: 'site-loader',
  //     data: {
  //     }
  //   });

  //   dialogRef.afterClosed().pipe(takeUntil(this.destroyemr$)).subscribe(result => {

  //   });
  // }
  // toggleActivevalue:number =0;
  // toggleActive(id:any){
  //  this.toggleActivevalue =id;
  // }
  addNewWorkup() {

    if (
      this.newdrworkupid != null &&
      this.newdrworkupid > 0 &&
      this.newdrworkupid != undefined
    ) {
      var checkdata = [];
      if (this.authService.Loggeduser.usertypeid == 6) {
        this.newdrworkupid = this.authService.Loggeduser.userid;
      }
   
      const today = Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd")!);
      checkdata = this.opdvisitService.visitdates.filter(item => {
        const doctorMatch = item.doctorId != null
          ? item.doctorId === this.newdrworkupid
          : item.visitDoctorId === this.newdrworkupid;

        const dateMatch = Date.parse(this.datepipe.transform(item.visitDate, "yyyy-MM-dd")!) === today;

        return doctorMatch && dateMatch;
      });
      //  checkdata = this.opdvisitService.visitdates.filter(item => item.doctorId != null ? item.doctorId == this.newdrworkupid : item.visitDoctorId == this.newdrworkupid && Date.parse(this.datepipe.transform(new Date(this.authService.localDate), "yyyy-MM-dd").toString()) == Date.parse(this.datepipe.transform(item.visitDate, "yyyy-MM-dd").toString()));
      if (checkdata.length == 0) {

        const payload = {
          "fK_RegId": this.opdvisitService.patientdetails.pkRegId,
          "fK_VisitId": this.opdvisitService.visitdates[0].fK_VisitId,
          "pK_ExamId": null,
          "fK_BranchId": this.opdvisitService.visitdates[0].fK_BranchId,
          "branchName": this.opdvisitService.visitdates[0].branchName,
          "visitDate": this.opdvisitService.visitdates[0].visitDate,
          "doctorId": this.newdrworkupid,
          "opId": null,
          "drName": this.opdvisitService.doctors.filter(item => item.userId == this.newdrworkupid)[0]?.userName,
          "opName": null,
          "subSpecialityName": null,
          "imageName": null,
          "visitDoctorId": this.newdrworkupid,
          "visitDrName": null,
          "visitSubSpecialityName": null,
          "fK_ImageTemplateId": null,
          "templateName": null,
          "imageNameTemplate": null,
          "branchCode": this.opdvisitService.visitdates[0].branchCode,
          "drNameShort": this.opdvisitService.doctors.filter(item => item.userId == this.newdrworkupid)[0]?.shortName,
          "opNameShort": null,
          "visitDrNameShort": null,
          "arId": null,
          "reportingTime": this.opdvisitService.visitdates[0].visitDate,
          "returnTime": null,
          "paidAmount": null,
          "billingAmount": null,
          "visitType": this.opdvisitService.visitdates[0].visitType,
          "billStatus": this.opdvisitService.visitdates[0].billStatus,

        };

        var vistdata = []
        vistdata.push(payload);
        this.opdvisitService.visitdates = vistdata.concat(this.opdvisitService.visitdates);
        this.emrservice.visitid = this.opdvisitService.visitdates[0].fK_VisitId
        this.emrservice.examid = 0;
        this.dashboardService.selectedRowIndex = 0;
        this.opdvisitService.visitid = this.opdvisitService.visitdates[0].fK_VisitId,
          this.emrservice.visitDate = this.opdvisitService.visitdates[0].visitDate;
        this.opdvisitService.DoctorIdEmr = this.newdrworkupid;
        this.dataSource = new MatTableDataSource(
          this.opdvisitService.visitdates.slice()
        );
        this.emrservice.drWorkupExamStatus(
          this.emrservice.visitid,
          this.emrservice.examid != null ? this.emrservice.examid : 0
        );
        this.emrservice.GetFindingGResultByregidd(
          this.opdvisitService.patientdetails.pkRegId,
          this.opdvisitService.visitid,
          this.opdvisitService.DoctorIdEmr,
          0
        );
      } else {
        this.opdvisitService.openSnackBar("Doctor can not create another workup after creating the one on the same date.", "ok");
      }
      // let payload = {
      //   DrExam: {
      //     pK_ExamId: 0,
      //     fK_VisitId: this.opdvisitService.visitid,
      //     fK_DoctorId: this.newdrworkupid,
      //     nextReview: null,
      //     nextReviewUnit: 0,
      //     nextReviewDate: this.datepipe.transform(
      //       this.authService.localDate,
      //       "yyyy-MM-dd"
      //     ),
      //     isReferredTo: false,
      //     referralReason: null,
      //     isUnderGVP: false,
      //     isAdviced: false,
      //     drRemarks: null,
      //     nextVisitPlan: null,
      //     prognosis: null,
      //     nutritionalAdvice: null,
      //     examinationComments: null,
      //     diagnosisComments: null,
      //     isDrugSide: false,
      //     isInvSide: false,
      //     isSurgRisk: false,
      //     fK_ConsId: 0,
      //     pK_SynchId: null,
      //     oldExamID: this.emrservice.examid ? this.emrservice.examid : 0,
      //     olddrname: null,
      //     oldvisitdate: null,
      //     regionalRemarks: null,
      //     pG_Doctor: null,
      //     personalRemarks: null,
      //     remarksForCounselor: null,
      //     gvpType: null,
      //     drFristDateTimeWorkup: moment(this.emrservice.holdtimeDoctor).format("HH:mm:ss"),
      //     drFristDateTimeWorkupFinish:null,
      //     pain_score: null,
      //     pain_Onset: null,
      //     pain_location: null,
      //     aggravating_with: null,
      //     characteristic: null,
      //     pain_duration: null,
      //     isFillByOpto: null,
      //     fK_OptoId: null,
      //     immunization: null,
      //     fallRisk: null,
      //     isNextReviewSmsSent: null,
      //     nextReviewNote: null,
      //     newRegionalRemarks: null,
      //     investigationRemarks: null,
      //     managmentRemarks: null,
      //     isSentSMS: null,
      //     isReviewSMS: null,
      //     isPopupMessage: null,
      //     tpEnd: null,
      //     keyword: null,
      //     otCheckDetail: null,
      //     requestToOtherDoctor: null,
      //     fK_RequestDoctorId: null,
      //     isSurgeryAdvised: null,
      //     fK_DoctorDeptID: null,
      //     isConverted: null,
      //     fK_Convert_OTID: null,
      //     isCrossedSeen: null,
      //     drName: this.opdvisitService.doctors.filter(
      //       (item) => item.userId == this.newdrworkupid
      //     )[0]?.userName,
      //     requestDoctorName: null,
      //     ageYear: this.opdvisitService.patientdetails.ageYear,
      //     ageMonth: this.opdvisitService.patientdetails.ageMonth,
      //     ageDays: this.opdvisitService.patientdetails.ageDays,
      //     doctorName: this.opdvisitService.doctors.filter(
      //       (item) => item.userId == this.newdrworkupid
      //     )[0]?.shortName,
      //     visitDate: this.datepipe.transform(
      //       this.authService.localDate,
      //       "yyyy-MM-dd"
      //     ),
      //     branchCode: this.authService.Branches.filter(
      //       (br) => br.pkBranchId == this.authService.Loggeduser.branchid
      //     )[0]?.branchCode,
      //     imgRegId: 0,
      //     proRegId: null,
      //     isEdit: false,
      //   },

      //   DrFinding: [],
      //   DrDiag: [],
      //   DrPrescrip: [],
      //   DrInvest: [],
      //   DrSurgery: [],
      // };
      // this.emrservice
      //   .SaveDrwrokupData(payload)
      //   .pipe(takeUntil(this.destroyinves$))
      //   .subscribe((data) => {
      //     if (data["statusCode"] == 1) {
      //       this.get_visit_dates(1);
      //     } else if (data["statusCode"] == 7) {
      //       this.opdvisitService.openSnackBar(
      //         "Doctor can not create another workup after creating the one on the same date.",
      //         "ok"
      //       );
      //     }
      //   });
    } else {
      this.opdvisitService.openSnackBar("Please Select Doctor Name", "ok");
    }
  }

  selectrow(row, index: any) {
    this.showspinner = true;
    this.dashboardService.selectedRowIndex = index;
    this.emrservice.visitid = row.fK_VisitId;
    this.emrservice.examid = row.pK_ExamId;
    this.opdvisitService.visitid = row.fK_VisitId;
    this.emrservice.visitDate = row.visitDate;
    if (row.doctorId != null) {
      this.opdvisitService.DoctorIdEmr = row.doctorId;
    }
    if (this.emrservice.pasthistoryPermission?.webIsMenu == true || this.emrservice.surgicalhistoryPermission?.webIsMenu == true) {
      this.emrservice.getHistoryStatus(this.opdvisitService.visitid);


    }
    this.newdrworkupid = this.opdvisitService.DoctorIdEmr;
    if (this.emrservice.examid != null && this.emrservice.examid > 0) {
      this.GetFitnessCheckUpDetail();
      if (
        this.emrservice.doctorPermission?.webIsMenu == true &&
        this.emrservice.doctorPermission?.pk_WebMenuUserPermissionDetailId !=
        null
      ) {
        this.emrservice.GetFindingGResultByregidd(
          this.opdvisitService.patientdetails.pkRegId,
          this.opdvisitService.visitid,
          this.opdvisitService.DoctorIdEmr,
          1
        );
        this.emrservice.drWorkupExamStatus(
          this.emrservice.visitid,
          this.emrservice.examid != null ? this.emrservice.examid : 0
        );
      }
      if (
        this.emrservice.primaryExamPermission?.webIsMenu == true &&
        this.emrservice.primaryExamPermission
          ?.pk_WebMenuUserPermissionDetailId != null
      ) {
        this.get_opto_data();
        this.getIOPDetailsbyRegId();
        this.getAutoRef();
        this.getCurrentMedication();
      }
      if (
        (this.emrservice.primaryExamPermission?.webIsMenu == true &&
          this.emrservice.primaryExamPermission
            ?.pk_WebMenuUserPermissionDetailId != null) ||
        (this.emrservice.counselorPermission?.webIsMenu == true &&
          this.emrservice.counselorPermission
            ?.pk_WebMenuUserPermissionDetailId != null)
      ) {
        this.emrservice.getPExamStatus();
      }
      this.emrservice.content.next("3");
    } else {
      this.emrservice
        .getCareVisit(row.fK_VisitId, this.opdvisitService.DoctorIdEmr)
        .pipe(takeUntil(this.destroyemr$))
        .subscribe((x: any) => {
          this.emrservice.visitid = x[0].fK_VisitId;
          this.opdvisitService.visitid = this.emrservice.visitid;
          this.dashboardService.selectedRowIndex = index;
          let examid = this.opdvisitService.visitdates.filter(
            (item) => item.fK_VisitId == this.emrservice.visitid
          );
          this.emrservice.examid = examid[0].pK_ExamId;
          this.emrservice.visitDate = examid[0].visitDate;
          if (examid[0].doctorId != null && examid[0].doctorId > 0) {
            this.opdvisitService.DoctorIdEmr = examid[0].doctorId;
          } else {
            this.opdvisitService.DoctorIdEmr = examid[0].visitDoctorId;
          }
          this.GetFitnessCheckUpDetail();
          this.emrservice.content.next("3");
          if (
            this.emrservice.primaryExamPermission?.webIsMenu == true &&
            this.emrservice.primaryExamPermission
              ?.pk_WebMenuUserPermissionDetailId != null
          ) {
            this.get_opto_data();
            this.getIOPDetailsbyRegId();
            this.getAutoRef();
            this.getCurrentMedication();
          }
          if (
            (this.emrservice.primaryExamPermission?.webIsMenu == true &&
              this.emrservice.primaryExamPermission
                ?.pk_WebMenuUserPermissionDetailId != null) ||
            (this.emrservice.counselorPermission?.webIsMenu == true &&
              this.emrservice.counselorPermission
                ?.pk_WebMenuUserPermissionDetailId != null)
          ) {
            this.emrservice.getPExamStatus();
          }
          if (
            this.emrservice.doctorPermission?.webIsMenu == true &&
            this.emrservice.doctorPermission
              ?.pk_WebMenuUserPermissionDetailId != null
          ) {
            this.emrservice.GetFindingGResultByregidd(
              this.opdvisitService.patientdetails.pkRegId,
              this.opdvisitService.visitid,
              this.opdvisitService.DoctorIdEmr,
              1
            );
            this.emrservice.drWorkupExamStatus(
              this.emrservice.visitid,
              this.emrservice.examid != null ? this.emrservice.examid : 0
            );
          }
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
    }
    setTimeout(() => {
      this.showspinner = false;
    }, 2000);
  }
  getAutoRef() {
    this.emrservice
      .get_ar_data()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data) => {
        this.emrservice.autoref = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  load_data_basedon_visitid() {
    // this.open_loader_Dialog();

    //api count starts from here
    this.get_complaints_PE();
    this.get_IOP_PE();
    this.get_opto_data();
    this.get_ar_data();

    this.get_student_opto_list();
    // this.emrservice.content.next('5');
  }

  get_student_opto_list() {
    this.emrservice
      .get_student_opto_list()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (data) => this.success_student_opto_list(data),
        (err) => this.failed_student_opto_list(err)
      );
  }

  success_student_opto_list(data) {
    this.emrservice.students_opto_list = data;
    if (data.length == 0) {
      this.emrservice.students_opto = {};
    }
    this.getapicount();
  }

  failed_student_opto_list(err) {
    this.getapicount();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  // success_student_opto(data){
  // this.emrservice.students_opto = data;
  // console.log ("student opto count " + this.emrservice.students_opto.optoStudent);
  // this.getapicount();
  // }

  // failed_student_opto(err){
  //   this.dashboardService.openSnackBar("student opto api failed","OK");
  //   this.getapicount();
  // }

  get_opto_data() {
    this.emrservice
      .get_opto_data()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (data) => this.success_opto_data(data),
        (err) => this.failed_opto_data(err)
      );
  }
  success_opto_data(data) {
    if (data != null) {
      this.emrservice.opto = data;
    } else {
      this.emrservice.opto = {};
    }

    let advisedId = this.emrservice.opto.fkGpadvicedById;
    if (advisedId != 0 && advisedId != null) {
      let getAdvisedid = this.authService.users.filter(
        (item) => item.pkUserId == advisedId
      )[0];
      this.ischecked = true;
      this.advisedName = getAdvisedid.userName;
    }

    this.getapicount();
  }

  failed_opto_data(err) {
    this.emrservice.opto = {};
    this.getapicount();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  get_ar_data() {
    //AutoRef/GetARdata/visitId
    this.emrservice
      .get_ar_data()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (data) => this.success_ar_data(data),
        (err) => this.failed_ar_data(err)
      );
  }

  success_ar_data(data) {
    if (data != null) {
      this.emrservice.autoref = data;
    } else {
      this.emrservice.autoref = {};
    }

    //console.log("ar data " + this.emrservice.autoref);
    this.getapicount();
  }

  failed_ar_data(err) {
    this.emrservice.autoref = {};
    this.getapicount();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  get_complaints_PE() {
    this.emrservice
      .get_complaints_PE()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (data) => this.success_complaints(data),
        (err) => this.failed_complaints(err)
      );
  }
  success_complaints(data) {
    this.emrservice.presentingcomplaints = data;
    //this.get_IOP_PE();
    this.getapicount();
  }

  get_IOP_PE() {
    this.emrservice
      .get_iop_list_PE()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (data) => this.success_iop_list(data),
        (err) => this.failed_iop_list(err)
      );
  }
  success_iop_list(data) {
    this.emrservice.intraocularpressure = data;
    this.getapicount();
    // this.intraocular_pressure_ds = new MatTableDataSource (this.emrservice.intraocularpressure.slice().reverse());
    // this.dashboardService.openSnackBar("complaints get successfully", "OK");
  }
  failed_iop_list(err) {
    this.getapicount();
    // this.dashboardService.openSnackBar("get iop list failed ", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  failed_complaints(err) {
    this.getapicount();
    // this.dashboardService.openSnackBar("get complaints api failed ", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  getapicount() {
    this.dialog.closeAll();
    this.apicount = this.apicount + 1;
    if (this.apicount == 5) {
      this.dialog.closeAll();

      // this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
      // this.router.navigate(['/layout/EMR']));
    }
  }

  // diabeticsurvey() {
  //   const dialogRef = this.dialog.open(Diabetic_SurveyComponent, {

  //     panelClass: 'full-width-dialog',
  //     maxWidth: '100vw !important',

  //     width: '60%',
  //     data: {

  //     }

  //   });

  //   dialogRef.afterClosed().pipe(takeUntil(this.destroyemr$)).subscribe(result => {

  //   });
  // }
  chkvisit() {
    // console.log ("this function called " + this.emrservice.visitid);
    if (this.emrservice.visitid > 0) {
      return false;
    } else {
      return true;
    }
  }
  chkdoc_or_op(value: string) {
    if (value != null) {
      return "#24ad1d";
    }
  }

  chkvalue(value: string) {
    if (value == null) {
      return "NF";
    }

    return value;
  }

  get_visit_dates(type: any) {
    // if (this.authService.masterdata.defaultView == 'C' || this.authService.masterdata.defaultView == null || this.authService.masterdata.defaultView == '') {
    //   this.emrBTN(this.consultationSection);
    // }
    //  this.open_loader_Dialog();
    this.showspinner = true;
    if (this.authService.masterdata.emrLevel == 3) {
      this.emrservice
        .getCareVisit(
          this.opdvisitService.visitid,
          this.opdvisitService.DoctorIdEmr
        )
        .pipe(takeUntil(this.destroyemr$))
        .subscribe(
          (x: any) => {

            this.opdvisitService.visitdates = x.sort((a, b) => {
              return (
                <any>new Date(b.visitDate) - <any>new Date(a.visitDate) ||
                <any>b.pK_ExamId - <any>a.pK_ExamId
              );
            });
            this.dataSource = new MatTableDataSource(
              this.opdvisitService.visitdates.slice()
            );
            this.emrservice.visitid =
              this.opdvisitService.visitdates[0].fK_VisitId;
            this.opdvisitService.visitid = this.emrservice.visitid;
            this.dashboardService.selectedRowIndex = 0;
            let examid = this.opdvisitService.visitdates.filter(
              (item) => item.fK_VisitId == this.emrservice.visitid
            );
            this.emrservice.examid = examid[0].pK_ExamId;
            this.emrservice.visitDate = examid[0].visitDate;
            if (examid[0].doctorId != null && examid[0].doctorId > 0) {
              this.opdvisitService.DoctorIdEmr = examid[0].doctorId;
            } else {
              this.opdvisitService.DoctorIdEmr = examid[0].visitDoctorId;
            }


            if (type == 0) {
              if (
                (this.emrservice.primaryExamPermission?.webIsMenu == true &&
                  this.emrservice.primaryExamPermission
                    ?.pk_WebMenuUserPermissionDetailId != null) ||
                (this.emrservice.counselorPermission?.webIsMenu == true &&
                  this.emrservice.counselorPermission
                    ?.pk_WebMenuUserPermissionDetailId != null)
              ) {
                this.emrservice.getPExamStatus();
              }
              if (
                this.emrservice.doctorPermission?.webIsMenu == true &&
                this.emrservice.doctorPermission
                  ?.pk_WebMenuUserPermissionDetailId != null
              ) {
                this.emrservice.drWorkupExamStatus(
                  this.emrservice.visitid,
                  this.emrservice.examid != null ? this.emrservice.examid : 0
                );
              }
              if (
                this.emrservice.historyPermission?.webIsMenu == true &&
                this.emrservice.historyPermission
                  ?.pk_WebMenuUserPermissionDetailId != null
              ) {
              } else if (
                this.emrservice.primaryExamPermission?.webIsMenu == true &&
                this.emrservice.primaryExamPermission
                  ?.pk_WebMenuUserPermissionDetailId != null
              ) {
                this.onSectionChange("section7");
              } else if (
                this.emrservice.doctorPermission?.webIsMenu == true &&
                this.emrservice.doctorPermission
                  ?.pk_WebMenuUserPermissionDetailId != null
              ) {
                this.onSectionChange("section19");
              }
              if (this.opdvisitService.patientdetails.pkRegId > 0) {
                this.callpatientstatus(
                  this.opdvisitService.patientdetails.pkRegId,
                  this.datepipe.transform(
                    this.emrservice.visitDate,
                    "yyyy-MM-dd"
                  )
                );
              }
            } else if (type == 1) {
              this.emrservice.drWorkupExamStatus(
                this.emrservice.visitid,
                this.emrservice.examid != null ? this.emrservice.examid : 0
              );
              this.emrservice.GetFindingGResultByregidd(
                this.opdvisitService.patientdetails.pkRegId,
                this.opdvisitService.visitid,
                this.opdvisitService.DoctorIdEmr,
                0
              );
            }
            //  this.dialog.closeAll();
            this.pageload = true;
            this.showspinner = false;
          },
          (err) => {
            // this.dialog.closeAll();
            this.pageload = true;
            this.showspinner = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    } else {
      this.emrservice
        .getCareVisit(0, 0)
        .pipe(takeUntil(this.destroyemr$))
        .subscribe(
          (x: any) => {
            // if (this.authService.masterdata.defaultView == 'C' || this.authService.masterdata.defaultView == null || this.authService.masterdata.defaultView == '') {
            //   this.emrBTN(this.consultationSection);
            // }
            this.opdvisitService.visitdates = x.sort((a, b) => {
              return (
                <any>new Date(b.visitDate) - <any>new Date(a.visitDate) ||
                <any>b.pK_ExamId - <any>a.pK_ExamId
              );
            });

            this.dataSource = new MatTableDataSource(
              this.opdvisitService.visitdates.slice()
            );

            this.emrservice.visitid =
              this.opdvisitService.visitdates[0].fK_VisitId;
            this.dashboardService.selectedRowIndex = 0;
            let examid = this.opdvisitService.visitdates.filter(
              (item) => item.fK_VisitId == this.emrservice.visitid
            );
            this.emrservice.examid = examid[0].pK_ExamId;
            this.emrservice.visitDate = examid[0].visitDate;
            this.opdvisitService.visitid = this.emrservice.visitid;
            if (examid[0].doctorId != null && examid[0].doctorId > 0) {
              this.opdvisitService.DoctorIdEmr = examid[0].doctorId;
            } else {
              this.opdvisitService.DoctorIdEmr = examid[0].visitDoctorId;
            }
            if (type == 0) {
              if (
                (this.emrservice.primaryExamPermission?.webIsMenu == true &&
                  this.emrservice.primaryExamPermission
                    ?.pk_WebMenuUserPermissionDetailId != null) ||
                (this.emrservice.counselorPermission?.webIsMenu == true &&
                  this.emrservice.counselorPermission
                    ?.pk_WebMenuUserPermissionDetailId != null)
              ) {
                this.emrservice.getPExamStatus();
              }
              if (
                this.emrservice.doctorPermission?.webIsMenu == true &&
                this.emrservice.doctorPermission
                  ?.pk_WebMenuUserPermissionDetailId != null
              ) {
                this.emrservice.drWorkupExamStatus(
                  this.emrservice.visitid,
                  this.emrservice.examid != null ? this.emrservice.examid : 0
                );
              }
              if (
                this.emrservice.historyPermission?.webIsMenu == true &&
                this.emrservice.historyPermission
                  ?.pk_WebMenuUserPermissionDetailId != null
              ) {
              } else if (
                this.emrservice.primaryExamPermission?.webIsMenu == true &&
                this.emrservice.primaryExamPermission
                  ?.pk_WebMenuUserPermissionDetailId != null
              ) {
                this.onSectionChange("section7");
              } else if (
                this.emrservice.doctorPermission?.webIsMenu == true &&
                this.emrservice.doctorPermission
                  ?.pk_WebMenuUserPermissionDetailId != null
              ) {
                this.onSectionChange("section19");
              }
              if (this.opdvisitService.patientdetails.pkRegId > 0) {
                this.callpatientstatus(
                  this.opdvisitService.patientdetails.pkRegId,
                  this.datepipe.transform(
                    this.emrservice.visitDate,
                    "yyyy-MM-dd"
                  )
                );
              }
            } else if (type == 1) {
              this.emrservice.drWorkupExamStatus(
                this.emrservice.visitid,
                this.emrservice.examid != null ? this.emrservice.examid : 0
              );
              this.emrservice.GetFindingGResultByregidd(
                this.opdvisitService.patientdetails.pkRegId,
                this.opdvisitService.visitid,
                this.opdvisitService.DoctorIdEmr,
                0
              );
            }
            //  this.dialog.closeAll();
            this.pageload = true;
            this.showspinner = false;
          },
          (err) => {
            // this.dialog.closeAll();
            this.pageload = true;
            this.showspinner = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  // success_visitlist(data) {
  //   this.opdvisitService.visitdates = data;
  // }
  failed_visitlist(err) {
    this.dialog.closeAll();
  }
  callpatientstatus(regid: any, visitdate: any) {
    var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementApply_YN");
    var queueurl = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementURL");
    var queuetoken = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagement_APIKey");
    if (queueproty[0]?.propertyValue == 'Y' && queueurl[0]?.propertyValue != null && queueurl[0]?.propertyValue != undefined && queuetoken[0]?.propertyValue != null && queuetoken[0]?.propertyValue != undefined) {
      this.QMYN = true;
      const headers = new HttpHeaders().set('X-API-KEY', `${queuetoken[0]?.propertyValue}`);
      this.http
        .get<any>(
          queueurl[0]?.propertyValue +
          "Interface/GetVisitcalldetails/" +
          regid +
          "/" +
          visitdate + '/' + this.authService.Loggeduser.branchid,
          { headers }
        )
        .pipe(takeUntil(this.destroyemr$))
        .subscribe((resp) => {
          this.callstausModelobj = resp;
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
    }
  }
  ChangeCallStatus(objdata: any, roomName: any, loginroomId: number, type: any) {
    var queueproty = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementApply_YN");
    var queueurl = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagementURL");
    var queuetoken = this.opdvisitService.documentrul.filter(item => item?.propertyName == "QueManagement_APIKey");
    if (queueproty[0]?.propertyValue == 'Y' && queueurl[0]?.propertyValue != null && queueurl[0]?.propertyValue != undefined && queuetoken[0]?.propertyValue != null && queuetoken[0]?.propertyValue != undefined) {
      if (objdata.fK_VisitId > 0) {
        let queuevisitObj = {
          PK_VisitId: objdata.pK_VisitId,
          FK_RegID: this.opdvisitService.patientdetails.pkRegId,
          fk_visitid: objdata.fK_VisitId,
          Remarks: type,
          RoomName: roomName,
          Fk_CreatedById: this.authService.Loggeduser.userid,
          Fk_RoomId: loginroomId ? loginroomId : this.authService.Loggeduser.roomid,
          fk_branchid: this.authService.Loggeduser.branchid,
        };
        const headers = new HttpHeaders().set('X-API-KEY', `${queuetoken[0]?.propertyValue}`);
        this.http
          .get<any>(
            queueurl[0]?.propertyValue +
            "Interface/GetAllCallingStatusByBranchId/" +
            this.authService.Loggeduser.branchid,
            { headers }
          )
          .pipe(takeUntil(this.destroyemr$))
          .subscribe((checkresp: any) => {

            var callapi = true;
            var checkdata = [];
            if (checkresp.length > 0) {
              checkdata = checkresp.filter(data => data.fK_DoctorId == this.opdvisitService.DoctorIdEmr);
              if (checkdata.length > 0 && type == "CALL") {
                callapi = false;
              } else {
                callapi = true;
              }
            } else {
              callapi = true;
            }

            if (callapi == true) {
              this.http
                .get<any>(
                  queueurl[0]?.propertyValue +
                  "Interface/GetVisitcalldetails/" +
                  this.opdvisitService.patientdetails.pkRegId +
                  "/" +
                  this.datepipe.transform(this.emrservice.visitDate, "yyyy-MM-dd") + '/' + this.authService.Loggeduser.branchid,
                  { headers }
                )
                .pipe(takeUntil(this.destroyemr$))
                .subscribe((resp) => {
                  this.callstausModelobj = resp;

                  if (type == "CALL" && this.callstausModelobj.isCall == "Y") {
                    return this.dashboardService.openSnackBar(
                      "Patient Already Called",
                      "OK"
                    );
                  } else if (
                    type == "DisConnect" &&
                    this.callstausModelobj.isCall == "N"
                  ) {
                    this.dashboardService.openSnackBar(
                      "Patient Already Aborted",
                      "OK"
                    );
                  } else {
                    this.http
                      .post<any>(
                        queueurl[0]?.propertyValue + "Interface/UpdatePatientCallStatus",
                        queuevisitObj,
                        { headers }
                      )
                      .pipe(takeUntil(this.destroyemr$))
                      .subscribe(
                        (resp) => {
                          if (this.opdvisitService.patientdetails.pkRegId > 0) {
                            this.callpatientstatus(
                              this.opdvisitService.patientdetails.pkRegId,
                              this.datepipe.transform(
                                this.emrservice.visitDate,
                                "yyyy-MM-dd"
                              )
                            );
                          }
                          if (type == "DisConnect") {
                            this.dashboardService.openSnackBar(
                              "Call aborted successfully",
                              "OK"
                            );
                          } else if (type == "CALL") {
                            this.dashboardService.openSnackBar(
                              "Patient called successfully",
                              "OK"
                            );
                          }
                        },
                        (err) => {
                          if (err.status == 403) {
                            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                          }
                          else if (err.error.statusCode == 422) {
                            this.dashboardService.openSnackBar(err.error.message, "OK");
                          }
                          else {
                            this.dashboardService.openSnackBar("API Failed", "OK");
                          }
                        }
                      );
                  }
                }, err => {
                  if (err.status == 403) {
                    this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                  }
                  else if (err.error.statusCode == 422) {
                    this.dashboardService.openSnackBar(err.error.message, "OK");
                  }
                  else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }
                });
            } else {
              this.dashboardService.openSnackBar(
                "Please Abort Patient Id " + checkdata[0].fK_RegID + " First",
                "OK"
              );
            }
          }, err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });

      }
    }
  }
  callPateintdata() { }
  tabclicked() {
    console.log("tab clicked " + this.tabGroup.selectedIndex);

    switch (this.tabGroup.selectedIndex) {
      case 0: {
        // history tab
        this.emrservice.tabindex = 0;
        break;
      }
      case 1: {
        // primary exam tab
        this.emrservice.tabindex = 1;
        this.emrservice.get_complaints_PE();
        break;
      }
      case 2: {
        // doctor  tab
        this.emrservice.tabindex = 2;
        break;
      }
      case 3: {
        // history tab
        this.emrservice.tabindex = 3;
      }
      case 4: {
        // history tab
        this.emrservice.tabindex = 4;
      }
    }
  }
  getdatafor_selected_date(selecteddate: string) { }

  private profileDetails: boolean = false;
  private historymini = false;
  private slider = true;
  historytoggleSidebar() {
    //
    if (this.historymini) {
      //   console.log("opening sidebar");
      this.profileDetails = false;
      document.getElementById("profile-details").style.width = "290px";
      document.getElementById("profile-details").style.display = "block";
      document.getElementById("history-tabs").style.marginLeft = "10px";
      // document.getElementById("profile-details").style.display = "block";
      this.historymini = false;
      this.slider = true;
    } else {
      //   console.log("closing sidebar");
      document.getElementById("profile-details").style.width = "0px";
      document.getElementById("profile-details").style.display = "none";
      document.getElementById("history-tabs").style.marginLeft = "10px";
      // document.getElementById("profile-details").style.display = "none";
      this.historymini = true;
      this.profileDetails = true;
      this.slider = false;
    }
  }
  scrollTo(section) {
    document.querySelector("#" + section).scrollIntoView();
    this.onSectionChange(section);
  }
  returnActiveclass(stype: any) {
    if (this.currentSection == stype) {
      return "active";
    } else {
      return "none-active";
    }
  }
  counsellorstatus: string = "pending";
  procedurestatus: string = "pending";
 
  returnstatuscolor(route) {
  const hs = this.emrservice.historyStatusresult[0] || {};
  const ps = this.emrservice.pExamStatusChk || {};
  const ws = this.emrservice.drWorkupStatus || {};
  const pExam = this.emrservice.pExamStatus?.[0] || {};

  const routeMap: { [key: string]: any } = {
    section1: hs.pastHistory,
    section2: hs.surgicalHistory,
    section3: hs.familyHistory,
    section4: hs.drugAllergy,
    section5: hs.otherInformation,
    section6: hs.socialHistory,
    section7: ps.presentingComplaints,
    section8: ps.autoRefractionDetails === 1 || ps.keratometerReadings === 1 ? 1 : 0,
    section10: ps.intraocularPressure,
    section11: ps.oldGlass,
    section12: ps.vision,
    section13: ps.unDilatedAndDilated,
    section14: ps.opdTest,
    section15: ps.glassPrescription,
    section16: ps.advisedInvestigations,
    section17: ps.optoSlitLampExamination,
    section18: ps.otherInformation,
    section19: ws.findingExamination,
    section20: ws.investigation,
    section21: ws.diagnosis,
    section22: ws.medicine,
    section23: ws.surgery,
    section24: ws.review,
    section25: ws.otherInformation,
    section26: pExam.counselorExamination,
    section27: pExam.procedureWorkup,
    section28: ps.currentMedication
  };

  // Save special statuses for section26 and section27 if needed
  if (route === "section26") {
    this.counsellorstatus = routeMap[route] === 1 ? "Complete" : "pending";
  } else if (route === "section27") {
    this.procedurestatus = routeMap[route] === 1 ? "Complete" : "pending";
  }

  return routeMap[route] === 1 ? "Complete" : "pending";
}

  pc: boolean = false;
  Drwork: boolean = false;
  onSectionChange(sectionId: string) {

    if (
      sectionId == "section1" ||
      sectionId == "section2" ||
      sectionId == "section3" ||
      sectionId == "section4" ||
      sectionId == "section5" ||
      sectionId == "section6"
    ) {
      var index = this.groupnewArray
        .map(function (img) {
          return img.webMenuGroupName.toLowerCase();
        })
        .indexOf("history");
      this.xpandStatus = index;
    }
    if (sectionId == "section27") {
      var index = this.groupnewArray
        .map(function (img) {
          return img.webMenuGroupName.toLowerCase();
        })
        .indexOf("procedure");
      this.xpandStatus = index;
    }
    // this._location.go(sectionId);
    this.currentSection = sectionId;
    if (sectionId == "section8" || sectionId == "section11") {
      this.emrservice.holdtimeAutoref = JSON.parse(sessionStorage.getItem('SessiondateTime'));
    } else if (
      sectionId == "section12" ||
      sectionId == "section13" ||
      sectionId == "section15" ||
      sectionId == "section18"
    ) {
      this.emrservice.holdtimeopto = JSON.parse(sessionStorage.getItem('SessiondateTime'));
    } else if (
      sectionId == "section19" ||
      sectionId == "section20" ||
      sectionId == "section21" ||
      sectionId == "section22" ||
      sectionId == "section23" ||
      sectionId == "section24" ||
      sectionId == "section25"
    ) {
      var index = this.groupnewArray
        .map(function (img) {
          return img.webMenuGroupName.toLowerCase();
        })
        .indexOf("doctor");
      this.xpandStatus = index;
      this.emrservice.holdtimeDoctor = JSON.parse(sessionStorage.getItem('SessiondateTime'));
      if (this.Drwork == false) {
        this.emrservice.GetFindingGResultByregidd(
          this.opdvisitService.patientdetails.pkRegId,
          this.opdvisitService.visitid,
          this.opdvisitService.DoctorIdEmr,
          0
        );
        this.Drwork = true;
      }
    } else if (sectionId == "section26") {
      this.emrservice.holdtimeCounselor = JSON.parse(sessionStorage.getItem('SessiondateTime'));
      var index = this.groupnewArray
        .map(function (img) {
          return img.webMenuGroupName.toLowerCase();
        })
        .indexOf("counselor");
      this.xpandStatus = index;
    }
    if (
      sectionId == "section7" ||
      sectionId == "section8" ||
      sectionId == "section11" ||
      sectionId == "section12" ||
      sectionId == "section13" ||
      sectionId == "section15" ||
      sectionId == "section18" ||
      sectionId == "section10" ||
      sectionId == "section14" ||
      sectionId == "section16" ||
      sectionId == "section17"
    ) {
      var index = this.groupnewArray
        .map(function (img) {
          return img.webMenuGroupName.toLowerCase();
        })
        .indexOf("primary exam");
      this.xpandStatus = index;
      if (this.pc == false) {
        if (
          this.emrservice.PresentingComplaintsPermission?.webIsMenu == true &&
          this.emrservice.PresentingComplaintsPermission
            ?.pk_WebMenuUserPermissionDetailId != null
        ) {
          this.emrservice.contentpex.next("section7");
        }
        if (
          (this.emrservice.autorefkeroPermission?.webIsMenu == true &&
            this.emrservice.autorefkeroPermission
              ?.pk_WebMenuUserPermissionDetailId != null) ||
          (this.emrservice.oldGlassPermission?.webIsMenu == true &&
            this.emrservice.oldGlassPermission
              ?.pk_WebMenuUserPermissionDetailId != null)
        ) {
          this.getAutoRef();
        }
        if (
          (this.emrservice.visionPermission?.webIsMenu == true &&
            this.emrservice.visionPermission
              ?.pk_WebMenuUserPermissionDetailId != null) ||
          (this.emrservice.unDilatedAndDilatedPermission?.webIsMenu == true &&
            this.emrservice.unDilatedAndDilatedPermission
              ?.pk_WebMenuUserPermissionDetailId != null) ||
          (this.emrservice.glassPrescriptionPermission?.webIsMenu == true &&
            this.emrservice.glassPrescriptionPermission
              ?.pk_WebMenuUserPermissionDetailId != null) ||
          (this.emrservice.postOpInformationPermission?.webIsMenu == true &&
            this.emrservice.postOpInformationPermission
              ?.pk_WebMenuUserPermissionDetailId != null)
        ) {
          this.get_opto_data();
        }
        if (
          this.emrservice.intraocularPressurePermission?.webIsMenu == true &&
          this.emrservice.intraocularPressurePermission
            ?.pk_WebMenuUserPermissionDetailId != null
        ) {
          this.emrservice.contentiop.next("section10");
        }
        if (
          this.emrservice.currentMPermission?.webIsMenu == true &&
          this.emrservice.currentMPermission
            ?.pk_WebMenuUserPermissionDetailId != null
        ) {
          this.getCurrentMedication();
        }
        if (
          this.emrservice.optometristPermission?.webIsMenu == true &&
          this.emrservice.optometristPermission
            ?.pk_WebMenuUserPermissionDetailId != null
        ) {
          this.emrservice.contentot.next("section14");
        }
        if (
          this.emrservice.advisedInvestigationsPermission?.webIsMenu == true &&
          this.emrservice.advisedInvestigationsPermission
            ?.pk_WebMenuUserPermissionDetailId != null
        ) {
          this.emrservice.contentai.next("section16");
        }
        if (
          this.emrservice.optoSliptLampPermission?.webIsMenu == true &&
          this.emrservice.optoSliptLampPermission
            ?.pk_WebMenuUserPermissionDetailId != null
        ) {
          this.emrservice.contentosle.next("section17");
        }
        this.pc = true;
      }
    }
    if (sectionId == "section27") {
      this.emrservice.holdtimeprocedure = JSON.parse(sessionStorage.getItem('SessiondateTime'));
      this.apiCallTrigger = true;
    }
  }

  getCurrentMedication() {
    this.emrservice
      .GetOpdCurrentMedication(this.emrservice.visitid)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (x: any) => {
          if (x.length > 0) {
            this.emrservice.medinicationMainArray = [];
            x.forEach((item) => {
              this.emrservice.medinicationMainArray.push({
                pK_TranId: item.pK_TranId,
                visitid: item.fK_VisitId,
                medicationType: item.medicationType,
                medicineName: item.medicineName,
                dosageCode: item.dosageCode,
                site: item.eye,
                remarks: item.remarks,
                fK_DosageId: item.fK_DosageId,
                pK_MedicineId: item.fK_MedicineId,
                dosageDescription: item.dosageDescription,
                isEdit: false,
                IsDeleted: false,
              });
            });
            this.emrservice.mediciation_dss = new MatTableDataSource(
              this.emrservice.medinicationMainArray.slice()
            );
          }
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  fitnessCheckup() {
    document.getElementById("fitnessCheckupModal").style.display = "block";
    this.GetFitnessCheckUpDetail();
    this.getFitnessCheckupList();
  }
  cancelfitnessCheckup() {
    document.getElementById("fitnessCheckupModal").style.display = "none";
  }

  prognosisNote() {
    document.getElementById("prognosisNoteModal").style.display = "block";
    this.GetFitnessCheckUpDetail();
    this.getFitnessCheckupList();
    this.getDiagnosisRegid(this.opdvisitService.patientdetails.pkRegId, 0, 0);
    this.getInvestDetails(
      this.opdvisitService.patientdetails.pkRegId,
      this.opdvisitService.visitid,
      this.opdvisitService.DoctorIdEmr
    );
    this.getPrescriptionDetails(this.opdvisitService.patientdetails.pkRegId);
    this.OPTObyRegId(this.opdvisitService.patientdetails.pkRegId);
    this.OtRegId(this.opdvisitService.patientdetails.pkRegId);
    this.getIOPDetailsbyRegId();
    this.getfindingbyredId();
  }
  cancelprognosisNote() {
    document.getElementById("prognosisNoteModal").style.display = "none";
  }



  getFitnessCheckupList() {
    this.emrservice
      .getFitnessCheckList()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (data) => this.successFitnesslist(data),
        (err) => this.failedFitnesslist(err)
      );
  }

  successFitnesslist(data) {
    this.ApprovalStatuslist = data;
  }

  failedFitnesslist(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  GetFitnessCheckUpDetail() {
    this.emrservice
      .GetFitnessCheckUpDetail()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (data) => this.successFitnessDetail(data),
        (err) => this.failedFitnessDetail(err)
      );
  }

  successFitnessDetail(data) {
    if (data.length > 0) {
      this.FitnessCheckupData = data[0];
    } else {
      this.FitnessCheckupData.approvedUserName =
        this.authService.masterdata.userName;
      this.FitnessCheckupData.fK_ApprovedById =
        this.authService.masterdata.pkUserId;
    }
  }

  failedFitnessDetail(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  changeValue(event, type) {
    switch (type) {
      case 1: {
        this.FitnessCheckupData.approvalStatus = event;
        break;
      }
      case 2: {
        this.FitnessCheckupData.comments = event;

        break;
      }
      case 3: {
        this.FitnessCheckupData.advisedInvestigation = event;
        break;
      }
      case 4: {
        this.FitnessCheckupData.advisedMedication = event;
        break;
      }
    }
  }
  public mini = true;
  emrLeftbar() {
    if (this.mini) {
      document.getElementById("emrLeftbar").style.display = "none";
      this.mini = false;
    } else {
      document.getElementById("emrLeftbar").style.display = "block";
      this.mini = true;
    }
  }

  SaveFitnessCheckupDetail() {
    if (!this.FitnessCheckupData.approvalStatus) {
      return this.dashboardService.openSnackBar(
        "Approval Status Rrequired",
        "OK"
      );
    }
    let payload = {
      FK_VisitId: this.emrservice.visitid,
      ApprovalStatus: this.FitnessCheckupData.approvalStatus,
      FK_ApprovedById: this.FitnessCheckupData.fK_ApprovedById,
      AdvisedInvestigation: this.FitnessCheckupData.advisedInvestigation,
      AdvisedMedication: this.FitnessCheckupData.advisedMedication,
      Comments: this.FitnessCheckupData.comments,
      PK_TranId: this.FitnessCheckupData.pK_TranId
        ? this.FitnessCheckupData.pK_TranId
        : 0,
      IsEdit: this.FitnessCheckupData.pK_TranId ? 1 : 0,
    };

    this.emrservice
      .SaveFitnessCheckupData(payload)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (data) => {
          if (data["statusCode"] == 1) {
            this.GetFitnessCheckUpDetail();
            this.dashboardService.openSnackBar(
              "Record Saved Successfully",
              "OK"
            );
            this.cancelfitnessCheckup();
          }
          // else {
          //   this.dashboardService.openSnackBar("API Failed", "OK");
          // }
        },
        (err) => {
          // this.dashboardService.openSnackBar(
          //   "API Failed :" + err.status + " Internal Server Error",
          //   "OK"
          // );
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  emrBTN(string) {
    //this.get_visit_dates();

    // if(this.emrservice.examid >0){
    // this.emrservice.content.next('2');
    // this.open_loader_Dialog();
    // setTimeout(()=>{
    //   this.dialog.closeAll();
    // }, 1000);

    // }

    if (this.consultationSection == string) {
      this.consultationSection = true;
      this.overviewSection = false;
    } else {
      this.consultationSection = false;
      this.overviewSection = true;
    }
  }

  public Labels = ["10/09/22", "10/09/22", "10/09/22"];
  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartData: ChartDataSets[] = [
    {
      data: [8, 10, 20, 7, 10],
      label: "OD",
      borderColor: "#00bcd4",
      borderWidth: 2,
      fill: false,
    },
    {
      data: [0, 20, 15, 15, 20],
      label: "OS",
      borderColor: "#2196f3",
      borderWidth: 2,
      fill: false,
    },
  ];
  public pieChartLabels: Label[] = this.Labels;
  public pieChartType: ChartType = "line";
  public pieChartLegend = true;
  public pieChartPlugins = [];

  // medicalRecord() {
  //   document.getElementById("medicalRecordModal").style.display = "block";
  //   this.GetFitnessCheckUpDetail();
  //   this.getFitnessCheckupList();
  // }
  // CancelmedicalRecord() {
  //   document.getElementById("medicalRecordModal").style.display = "none";
  // }

  //Dosage Time
  dosageTime() {
    document.getElementById("dosageTimeModal").style.display = "block";
    this.GetFitnessCheckUpDetail();
    this.getFitnessCheckupList();
  }
  CanceldosageTime() {
    document.getElementById("dosageTimeModal").style.display = "none";
  }

  color: any;
  _value: number = 0;
  _hourvalue: number = 0;
  _step: number = 1;
  _min: number = 0;
  _max: number = 60;
  _hourmax: number = 12;
  _wrap: boolean = false;

  myFormGroup = new FormGroup({
    formField: new FormControl(),
  });

  set inputValue(_value: number) {
    this._value = this.parseNumber(_value);
  }

  set step(_step: number) {
    this._step = this.parseNumber(_step);
  }

  set min(_min: number) {
    this._min = this.parseNumber(_min);
  }

  set max(_max: number) {
    this._max = this.parseNumber(_max);
  }

  set hourmax(_hourmax: number) {
    this._hourmax = this.parseNumber(_hourmax);
  }

  set wrap(_wrap: boolean) {
    this._wrap = this.parseBoolean(_wrap);
  }

  private parseNumber(num: any): number {
    return +num;
  }

  private parseBoolean(bool: any): boolean {
    return !!bool;
  }

  setColor(color: string): void {
    this.color = color;
  }

  getColor(): string {
    return this.color;
  }

  incrementValue(step: number = 1): void {
    let inputValue = this._value + step;

    if (this._wrap) {
      inputValue = this.wrappedValue(inputValue);
    }
    this._value = inputValue;
  }

  hoursincrementValue(step: number = 1): void {
    let hourinputValue = this._hourvalue + step;

    if (this._wrap) {
      hourinputValue = this.hourwrappedValue(hourinputValue);
    }

    this._hourvalue = hourinputValue;
  }

  private wrappedValue(inputValue): number {
    if (inputValue > this._max) {
      return this._min + inputValue - this._max;
    }

    if (inputValue < this._min) {
      if (this._max === 12) {
        return 0;
      }

      return this._max + inputValue;
    }

    return inputValue;
  }

  private hourwrappedValue(hourinputValue): number {
    if (hourinputValue > this._hourmax) {
      return this._min + hourinputValue - this._hourmax;
    }

    if (hourinputValue < this._min) {
      if (this._hourmax === 60) {
        return 0;
      }

      return this._hourmax + hourinputValue;
    }

    return hourinputValue;
  }

  shouldDisableDecrement(inputValue: number): boolean {
    return !this._wrap && inputValue <= this._min;
  }

  shouldDisableIncrement(inputValue: number): boolean {
    return !this._wrap && inputValue >= this._max;
  }

  hourshouldDisableDecrement(hourinputValue: number): boolean {
    return !this._wrap && hourinputValue <= this._min;
  }

  hourshouldDisableIncrement(hourinputValue: number): boolean {
    return !this._wrap && hourinputValue >= this._hourmax;
  }

  //Dosage Time
  searchRecord() {
    document.getElementById("searchRecordModal").style.display = "block";
    this.GetFitnessCheckUpDetail();
    this.getFitnessCheckupList();
  }
  cancelsearchRecord() {
    document.getElementById("searchRecordModal").style.display = "none";
  }

  getDiagnosisRegid(regid, visitid, docid) {
    this.emrservice
      .getDaigonosisbyRegid(regid, visitid, docid)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data: any[]) => {
        this.diagnosislist = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  getInvestDetails(regid, visitid, docid) {
    this.emrservice
      .GetInvestigationDetailByRegId(regid, visitid, docid)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data) => {
        this.investigationDetaillist = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  getPrescriptionDetails(regid) {
    this.emrservice
      .GetPrescriptionDetailByRegId(regid, 0, 0)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data) => {
        this.prescriptionDetaillist = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  OPTObyRegId(regid) {
    this.emrservice
      .getOptobyRegId(regid)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data) => {
        this.optoList = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  OtRegId(regid) {
    this.emrservice
      .getOtRedId(regid)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data) => {
        this.otsurgrylist = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  getIOPDetailsbyRegId() {
    this.emrservice
      .getIOPDetails()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data) => {
        this.iopdetailslist = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  getfindingbyredId() {
    this.emrservice.GetFindingByRegId(this.opdvisitService.patientdetails.pkRegId, 0, 0)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data: any[]) => {
        if (data.length > 0) {
          this.groupedFindingData = data.reduce((result, finding) => {
            const { findingName } = finding;
            let section = result.find(item => item.findingName === findingName);

            if (!section) {
              section = { findingName, findings: [] };
              result.push(section);
            }
            section.findings.push(finding);
            return result;
          }, []);

          this.groupedFindingData.forEach(section => {
            section.findings.sort((a, b) => {
              const dateA = new Date(a.visitDate).getTime();  // for sorting according to date by descending order
              const dateB = new Date(b.visitDate).getTime();
              return dateB - dateA;
            });
          });

          this.groupedFindingData.sort((a, b) => a.findingName.localeCompare(b.findingName)); // for sorting according to name by ascending order
          console.log(this.groupedFindingData, "findingdata with expanded initialized");
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  getsummary_url(patientid: number, type: number) {
    if (this.opdvisitService.patientdetails.pkRegId) {
      if (type == 0) {
        let checkreporttype = this.authService.webreportConfig.filter(
          (item) =>
            item.printOption == "Medical Record" &&
            item.printType == "NetramReport"
        );
        if (checkreporttype.length > 0) {
          this.dashboardService
            .getsummary_url()
            .pipe(takeUntil(this.destroyemr$))
            .subscribe(
              (data) => this.succesurl(data, patientid, type),
              (err) => this.failedurl(err)
            );
        } else {
          this.showspinner = true;
          this.printTimelineBill(1);
        }
      } else {
        this.dashboardService
          .getsummary_url()
          .pipe(takeUntil(this.destroyemr$))
          .subscribe(
            (data) => this.succesurl(data, patientid, type),
            (err) => this.failedurl(err)
          );
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }

  succesurl(data, patientid, type) {
    this.showspinner = false;
    const urldate = data.filter((item) => item.propertyName == "WebURL");
    const pageheader = data.filter(
      (item) => item.propertyName == "PageHeadWebReport"
    );
    const checktrue = pageheader[0]?.propertyValue;
    const url = urldate[0].propertyValue;
    if (type == 0) {
      var newWindow = window.open(
        url +
        "PatientEMRSummary.aspx?RegID=" +
        patientid +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&VisitOrderType=DESC" +
        "&BranchId=" +
        this.authService.Loggeduser.branchid
      );
    } else if (type == 1) {
      var newWindow = window.open(url + "ImageSummary.aspx?RegID=" + patientid);
    } else if (type == 2) {
      let vDate = this.datepipe.transform(
        this.emrservice.visitDate,
        "dd-MMM-yyyy"
      );
      window.open(
        url +
        "TodayEMRVisitDayCaseSheet.aspx?VisitId=" +
        this.emrservice.visitid +
        "&VisitDate=" +
        vDate +
        "&PageHeadWebReport=" +
        checktrue +
        "&BillCompanyName=" +
        this.authService.Loggeduser.billingcompanyname +
        "&VisitOrderType=ASC" +
        "&BranchId=" +
        this.authService.Loggeduser.branchid
      );
    } else if (type == 3) {

      this.emrservice
        .getProcedureData(patientid)
        .pipe(takeUntil(this.destroyemr$))
        .subscribe(
          (x: any) => {
            if (x.length > 0) {
              const prourl = data.filter(
                (item) => item.propertyName == "WebURLProcedure"
              );
              if (prourl.length > 0) {
                window.open(
                  url +
                  prourl[0]?.propertyValue +
                  "?RegID=" +
                  patientid +
                  "&BillCompanyName=" +
                  this.authService.Loggeduser.billingcompanyname +
                  "&PK_TransactionId=" +
                  0 +
                  "&BranchId=" +
                  this.authService.Loggeduser.branchid +
                  "&RegisterID=" +
                  0 +
                  "&ShowAllRegister=Y"
                );
              } else {
                this.dashboardService.openSnackBar(
                  "Please Add Procedure Name in DB Contest Table",
                  "OK"
                );
              }
            } else {
              this.dashboardService.openSnackBar(
                "Please Complete Procedure First",
                "OK"
              );
            }

          },
          (err) => { }
        );
    }
  }
  failedurl(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //priscription print
  prescriptionSetting: any = [];
  PrintList: any = [];
  getpreSetting(bachid, userid, data, type) {
    this.showspinner = true;
    if (this.emrservice.localStorePriscription.length == 0) {
      this.emrservice
        .GetPreSetting(bachid, userid, data)
        .pipe(takeUntil(this.destroyemr$))
        .subscribe((item) => {

          this.prescriptionSetting = [];
          this.PrintList = [];
          this.prescriptionSetting = item;

          this.PrintList = this.prescriptionSetting.filter(
            (x) => !x.colName.startsWith("Clear")
          );
          if (this.prescriptionSetting.length == 0) {
            this.defualtsetdata(data, type);
          } else {
            if (type == 0) {
              let checkreporttype = this.authService.webreportConfig.filter(
                (item) =>
                  item.printOption == "Prescription" &&
                  item.printType == "NetramReport"
              );
              if (checkreporttype.length > 0) {
                this.getprintReport_url(
                  this.opdvisitService.patientdetails.pkRegId
                );
              } else {
                this.printTimelineBill(0);
              }
            } else if (type == 2) {
              let checkreporttype = this.authService.webreportConfig.filter(
                (item) =>
                  item.printOption == "DailyCaseSheet" &&
                  item.printType == "WebNetramReport"
              );
              if (checkreporttype.length > 0) {
                this.showspinner = true;
                this.printTimelineBill(type);
              } else {
                this.dashboardService
                  .getsummary_url()
                  .pipe(takeUntil(this.destroyemr$))
                  .subscribe(
                    (data) => this.succesurl(data, this.opdvisitService.patientdetails.pkRegId, type),
                    (err) => this.failedurl(err)
                  );
              }
            }


          }
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
    } else {
      this.PrintList = [];
      this.PrintList = this.emrservice.localStorePriscription;
      // this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
      let checkreporttype = this.authService.webreportConfig.filter(
        (item) =>
          item.printOption == "Prescription" && item.printType == "NetramReport"
      );
      if (checkreporttype.length > 0) {
        this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
      } else {
        this.printTimelineBill(0);
      }
    }
  }
  defualtsetdata(data, type) {

    this.emrservice
      .GetPreSetting(1, 1, data)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((item) => {
        this.prescriptionSetting = [];
        this.PrintList = [];
        this.prescriptionSetting = item;

        this.PrintList = this.prescriptionSetting.filter(
          (x) => !x.colName.startsWith("Clear")
        );
        if (type == 0) {
          let checkreporttype = this.authService.webreportConfig.filter(
            (item) =>
              item.printOption == "Prescription" &&
              item.printType == "NetramReport"
          );
          if (checkreporttype.length > 0) {
            this.getprintReport_url(this.opdvisitService.patientdetails.pkRegId);
          } else {
            this.printTimelineBill(0);
          }
        } else if (type == 2) {
          let checkreporttype = this.authService.webreportConfig.filter(
            (item) =>
              item.printOption == "DailyCaseSheet" &&
              item.printType == "WebNetramReport"
          );
          if (checkreporttype.length > 0) {
            this.showspinner = true;
            this.printTimelineBill(type);
          } else {
            this.dashboardService
              .getsummary_url()
              .pipe(takeUntil(this.destroyemr$))
              .subscribe(
                (data) => this.succesurl(data, this.opdvisitService.patientdetails.pkRegId, type),
                (err) => this.failedurl(err)
              );
          }
        }

      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  getprintReport_url(patientid: number) {
    if (this.opdvisitService.patientdetails.pkRegId) {
      this.dashboardService
        .getsummary_url()
        .pipe(takeUntil(this.destroyemr$))
        .subscribe(
          (data) => this.succesurldata(data, patientid),
          (err) => this.failedurldata(err)
        );
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }
  PrescriptionMedicine: any;
  PageHeader: any;
  reporturl: any;
  succesurldata(data, patientid) {
    this.showspinner = false;
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      if (element.propertyName === "PrescriptionMedicinePattern") {
        this.PrescriptionMedicine = element;
      }

      if (element.propertyName === "PageHeadWebReport") {
        this.PageHeader = element;
      }

      if (element.propertyName === "WebURL") {
        this.reporturl = element.propertyValue;
      }
    }

    let vDate = this.datepipe.transform(
      this.emrservice.visitDate,
      "dd-MMM-yyyy"
    );

    var newWindow = window.open(
      this.reporturl +
      "Prescription.aspx?PrescriptionMedicinePattern=" +
      this.PrescriptionMedicine.propertyValue +
      "&BranchId=" +
      this.authService.Loggeduser.branchid +
      "&BillCompanyName=" +
      this.authService.Loggeduser.billingcompanyname +
      "&RegID=" +
      patientid +
      "&AgeDesc=" +
      this.opdvisitService.printpriciptionAge +
      "&VisitID=" +
      this.emrservice.visitid +
      "&VisitDate=" +
      vDate +
      "&ExamID=" +
      this.emrservice.examid +
      "&DoctorId=" +
      this.opdvisitService.DoctorIdEmr +
      "&" +
      this.PrintList[0].colName +
      "=" +
      (this.PrintList[0].colValue == true ? "Y" : "N") +
      "&PageHeadWebReport=" +
      (this.PrintList[13].colValue == true ? "Y" : "N") +
      "&PrintOPDTest=" +
      (this.PrintList[15].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[1].colName +
      "=" +
      (this.PrintList[1].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[2].colName +
      "=" +
      (this.PrintList[2].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[3].colName +
      "=" +
      (this.PrintList[3].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[4].colName +
      "=" +
      (this.PrintList[4].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[5].colName +
      "=" +
      (this.PrintList[5].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[6].colName +
      "=" +
      (this.PrintList[6].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[7].colName +
      "=" +
      (this.PrintList[7].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[8].colName +
      "=" +
      (this.PrintList[8].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[9].colName +
      "=" +
      (this.PrintList[9].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[10].colName +
      "=" +
      (this.PrintList[10].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[11].colName +
      "=" +
      (this.PrintList[11].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[12].colName +
      "=" +
      (this.PrintList[12].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[13].colName +
      "=" +
      (this.PrintList[13].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[14].colName +
      "=" +
      (this.PrintList[14].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[15].colName +
      "=" +
      (this.PrintList[15].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[16].colName +
      "=" +
      (this.PrintList[16].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[17].colName +
      "=" +
      (this.PrintList[17].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[18].colName +
      "=" +
      (this.PrintList[18].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[19].colName +
      "=" +
      (this.PrintList[19].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[20].colName +
      "=" +
      (this.PrintList[20].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[21].colName +
      "=" +
      (this.PrintList[21].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[22].colName +
      "=" +
      (this.PrintList[22].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[23].colName +
      "=" +
      (this.PrintList[23].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[24].colName +
      "=" +
      (this.PrintList[24].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[25].colName +
      "=" +
      (this.PrintList[25].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[26].colName +
      "=" +
      (this.PrintList[26].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[27].colName +
      "=" +
      (this.PrintList[27].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[28].colName +
      "=" +
      (this.PrintList[28].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[29].colName +
      "=" +
      (this.PrintList[29].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[30].colName +
      "=" +
      (this.PrintList[30].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[31].colName +
      "=" +
      (this.PrintList[31].colValue == true ? "Y" : "N") +
      "&" +
      this.PrintList[32].colName +
      "=" +
      (this.PrintList[32].colValue == true ? "Y" : "N") +
      "&UserTypeId=" +
      this.authService.Loggeduser.usertypeid +
      "&LanguageId=" +
      1 +
      "&ReportHeading=Prescription"
    );
  }
  failedurldata(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  getBranchDetail(id) {
    this.branchMatserService
      .getBrachMasterItem(id)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((x: any) => {
        this.emrservice.branchmansterObj = x[0];
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }

  printTimelineBill(type) {
    var printoption: string = '';
    if (type == 0) {
      printoption = 'Prescription'
    } else if (type == 1) {
      printoption = 'Medical Record'
    } else if (type == 2) {
      printoption = 'DailyCaseSheet'
      type = 0;
    }
    let payload = {
      WebReportPrintMaster: {
        module: "Doctor",
        printOption: printoption,
        printType: "WebNetramReport",
        PRINTDATE: this.datepipe.transform(
          this.authService.localDate,
          "dd/MM/yyyy"
        ),
        PrintTime: this.emrservice.convertTime12Hour(new Date()),
        Pk_RegId: this.opdvisitService.patientdetails.pkRegId,
        BILLINGCOMPANYNAME: this.authService.Loggeduser.billingcompanyname,
        PRINTCONFIGURATIONARRAY:
          type == 0 ? JSON.stringify(this.PrintList) : "N",
        Pk_VisitId: type == 0 ? this.emrservice.visitid : 0,
        Pk_ExamId: type == 0 ? this.emrservice.examid : 0,
        VISITDATE: this.datepipe.transform(
          this.emrservice.visitDate,
          "dd/MM/yyyy"
        ),
        LINE1: this.emrservice.branchmansterObj.line1,
        LINE2: this.emrservice.branchmansterObj.line2,
        LINE3: this.emrservice.branchmansterObj.line3,
        LINE4: this.emrservice.branchmansterObj.line4,
        HOSPITALIMAGE: "../../../" + this.authService.loginclientlogo,
        COMPANYIMAGE: "../../../" + this.authService.leftbottomlogosm,
        CERTIFICATE1IMAGE: "../../../" + this.authService.nabhlogo,
        CERTIFICATE2COMPANYIMAGE: "",
        PrintHeaderArray: "Y",
        PatientRegistrationArray: "Y",
        VisitMasterArray: type == 1 ? "Y" : "N",
        HistoryGeneralArray: "Y",
        DoctorExaminationMasterArray: "Y",
        AutoRefExaminationArray: "Y",
        HistoryDiseaseArray: "Y",
        CounselorExaminationArray: type == 1 ? "Y" : "N",
        HistorySurgicalArray: "Y",
        HistoryFamilyArray: "Y",
        HistoryDrugAllergyArray: "Y",
        PresentingComplaintsArray: "Y",
        AdvisedInvestigationsArray: "Y",
        IntraocularPressureArray: "Y",
        OptoExaminationArray: "Y",
        OptoTestDetailArray: "Y",
        OptoSlitLampExaminationArray: "Y",
        CurrentMedicationDetailArray: "Y",
        DoctorFindingArray: "Y",
        DoctorInvestigationArray: "Y",
        DoctorDiagnosisArray: "Y",
        DoctorPrescriptionArray: "Y",
        DoctorSurgeryArray: "Y",
        ProcedureRegisterArray: printoption == 'DailyCaseSheet' || 'Medical Record' ? "Y" : 'N'
      },
    };
    this.emrservice
      .GetWebReportPrint(payload)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (x: any) => {
          this.showspinner = false;
          if (x.length > 0) {
            let printContents, popupWin;

            printContents = x[0].printTemplate;
            popupWin = window.open(
              "",
              "_blank",
              "top=0,left=0,height=100%,width=auto"
            );

            popupWin.document.open();
            popupWin.document.write(`
  <html>
   
  <body onload="window.print()">${printContents}
  </body>
  </html>`);

            popupWin.document.close();
          } else {
            this.dashboardService.openSnackBar("Report Template Not Set", "OK");
          }
        },
        (err) => {
          this.showspinner = false;
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  opendocdialog(): void {
    let patientName =
      this.opdvisitService.patientdetails.firstName +
      " " +
      this.opdvisitService.patientdetails.lastName;
    const dialogRef = this.dialog.open(PatientdocsComponent, {
      panelClass: "full-width-dialog",

      width: "60%",
      data: {
        patID: this.opdvisitService.patientdetails.pkRegId,
        patientName: patientName,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((result) => { });
  }
  getdoccolor(emrflag: any) {
    if (emrflag != 0) {
      return "#24ad1d";
    }
  }
  checkstatus(value: number) {
    if (value > 0) {
      return this.authService.validationMsg["dashboardValidMsg.msg41"];
    } else {
      return this.authService.validationMsg["dashboardValidMsg.msg42"];
    }
  }
  //for examination Dr. search filter
  examinationFilter() {
    const query = this.filterQuery.trim().toLowerCase();
    this.filteredDataa = this.dataSource.filteredData.filter((item) => {
      if (item.drNameShort) {
        return item.drNameShort.toLowerCase().includes(query);
      }
      return true;
    });
  }
  doctorWorkupModal() {
    this.isReadonly = true;
    this.get_opto_data();
    this.examinationFilter();
    this.callForkjoin();
    this.call_DrWorkUp_GroupApi();
    this.inhouseseugery(this.opdvisitService.patientdetails.pkRegId);
    this.inhou_Investigation(this.opdvisitService.patientdetails.pkRegId);
    this.emrservice.GetFindingGResultByregidd(
      this.opdvisitService.patientdetails.pkRegId,
      this.opdvisitService.visitid,
      this.opdvisitService.DoctorIdEmr,
      0
    );
    this.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId);
    this.get_IOP_PE();
    document.getElementById("doctorWorkupModal").style.display = "block";
  }
  GetFindingGResultByregid(regid) {
    this.emrservice
      .GetFindingGResultByregid(
        regid,
        this.opdvisitService.visitid,
        this.opdvisitService.DoctorIdEmr
      )
      .subscribe((x: any) => {
        this.examdetailArray = [];
        this.emrservice.patientEMRdetail = [];
        this.emrservice.patientEMRdetail = x;
        this.examdetailArray = this.emrservice.patientEMRdetail.filter(
          (item) => item.pK_ExamId == this.emrservice.examid
        );
        //  this.GetSurgeryDetailByRegId(this.opdvisitService.patientdetails.pkRegId, this.emrservice.visitid, this.opdvisitService.DoctorIdEmr);
      }, err => {

        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  inhouseseugery(regid: any) {
    this.emrservice
      .inhouseSurgeries(regid)
      .pipe(takeUntil(this.destroypast$))
      .subscribe((data) => {
        this.datalist = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  inhou_Investigation(regid: any) {
    this.emrservice
      .getProcedureData(regid)
      .pipe(takeUntil(this.destroyemr$))
      .subscribe((data) => {
        this.inhouse_data = data;
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
  }
  callForkjoin() {
    forkJoin({
      pasthistorydata: this.emrservice.get_pasthistory(this.emrservice.visitid),
      surgeriesdata: this.emrservice.get_surgeries(this.emrservice.visitid),
      failyhistorydata: this.emrservice.get_familyhistory(),
      drugallerergydata: this.emrservice.get_allergies(),
      otherinfodata: this.emrservice.get_otherinfo(),
      complaintsdata: this.emrservice.get_complaints_PE(),
    })
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (results: any) => {
          this.emrservice.pasthistory = results.pasthistorydata;
          this.emrservice.presentingcomplaints = results.complaintsdata;
          this.sergi_history = results.surgeriesdata;
          this.emrservice.familyhistory = results.failyhistorydata;
          this.drug_data = results.drugallerergydata;
          this.emrservice.otherinfo_history = results.otherinfodata;
          var cacheBuster = Date.now();
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  historyforjoinvistid(visitid: any) {
    forkJoin({
      pasthistorydata: this.emrservice.pasthistoryPermission?.webIsMenu == true ? this.emrservice.get_pasthistory(visitid) : of([]),
      surgeriesdata: this.emrservice.surgicalhistoryPermission?.webIsMenu == true ? this.emrservice.get_surgeries(visitid) : of([]),

    })
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (results: any) => {
          this.emrservice.pasthistory = results.pasthistorydata;
          this.emrservice.surgicalhistory = results.surgeriesdata;
          this.sergi_history = results.surgeriesdata;
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  // -----call Group Api for Dr_workup
  call_DrWorkUp_GroupApi() {
    forkJoin({
      medicinedata: this.emrservice.GetPrescriptionDetailByRegId(
        this.opdvisitService.patientdetails.pkRegId,
        this.opdvisitService.visitid,
        this.opdvisitService.DoctorIdEmr
      ),
      drdaignosisdata: this.emrservice.getDaigonosisbyRegid(
        this.opdvisitService.patientdetails.pkRegId,
        this.opdvisitService.visitid,
        this.opdvisitService.DoctorIdEmr
      ),
      investigationdata: this.emrservice.GetInvestigationDetailByRegId(
        this.opdvisitService.patientdetails.pkRegId,
        this.opdvisitService.visitid,
        this.opdvisitService.DoctorIdEmr
      ),
      surgery_data: this.emrservice.GetSurgeryDetailByRegId(
        this.opdvisitService.patientdetails.pkRegId,
        this.emrservice.visitid,
        this.opdvisitService.DoctorIdEmr
      ),
      examination_data: this.emrservice.GetFindingByRegId(
        this.opdvisitService.patientdetails.pkRegId,
        this.opdvisitService.visitid,
        this.opdvisitService.DoctorIdEmr
      ),
    })
      .pipe(takeUntil(this.destroyemr$))
      .subscribe(
        (results: any) => {
          this.medicinedata = results.medicinedata;
          this.drdaignosisdata = results.drdaignosisdata;
          this.investigationdata = results.investigationdata;
          this.surgery_data = results.surgery_data;
          this.examination_data = results.examination_data;
          var cacheBuster = Date.now();
        },
        (err) => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }
  // --------Histroy pop_up module call--------
  pasthistorycomp() {
    if (this.emrservice.pasthistoryPermission?.isAddPermission == true) {
      const dialogRef = this.dialog.open(PastHistoryComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "90vw",
        maxHeight: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroypast$))
        .subscribe((result) => {
          this.callForkjoin();
          if (this.past_histroyApicall) {
            this.past_histroyApicall();
          }
          // this.emrservice.get_pasthistory().pipe(takeUntil(this.destroypast$)).subscribe(
          //   data => {
          //     this.past_history = data
          //     console.log(this.past_history, 'called past')
          //   }
          // )
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  Surgicalhistorycomp() {
    if (this.emrservice.surgicalhistoryPermission?.isAddPermission == true) {
      const dialogRef = this.dialog.open(SurgicalHistoryComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "90vw",
        maxHeight: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroypast$))
        .subscribe((result) => {
          this.callForkjoin();

          if (this.surgi_histroyApicall) {
            this.surgi_histroyApicall();
          }
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  allergyhistroycomp() {
    if (this.emrservice.drughistoryPermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(DrugAllergyComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "85vw",
        height: "70%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.callForkjoin();
        if (this.durgg_histroyApicall) {
          this.durgg_histroyApicall();
        }
        this.emrservice
          .get_allergies()
          .pipe(takeUntil(this.destroydrug$))
          .subscribe((data) => {
            this.drug_data = data;
          }, err => {
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          });
      });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  otherinfocompo() {
    if (this.emrservice.otherhistoryPermission?.isAddPermission == true) {
      const dialogRef = this.dialog.open(HistoryOtherInfoComponent, {
        panelClass: "history-other",
        maxWidth: "85vw",
        maxHeight: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.callForkjoin();
      });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  //---------- Primery_Exam pop_up module call ---------

  addIOPdetails() {
    if (
      this.emrservice.intraocularPressurePermission?.isAddPermission == true
    ) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(IOPComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "85vw",
        maxHeight: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroypast$))
        .subscribe((result) => {
          this.get_IOP_PE();
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  timeConvt(e) {
    return moment(e, "HH:mm").format("HH:mm");
  }
  visiondata() {
    if (this.emrservice.visionPermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(VisionComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "85vw",
        maxHeight: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroyvision$))
        .subscribe((result) => {
          this.get_opto_data();
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  refractiondata() {
    if (this.emrservice.glassPrescriptionPermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(Glass_prescriptionComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "85vw",
        maxHeight: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroyglass$))
        .subscribe((result) => {
          this.get_opto_data();
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  addDisabledbox(value) {
    // this.boxDisabled = value;
    this.emrservice.opto.nearType = value;
  }
  checknearvalue(value) {
    if (value) {
      return value;
    } else {
      this.emrservice.opto.nearType = "Add";
      return "Add";
    }
  }
  // presentComplaintscomp() {
  //   if (
  //     this.emrservice.PresentingComplaintsPermission?.isAddPermission == true
  //   ) {
  //     this.showmodeal = false;
  //     const dialogRef = this.dialog.open(Present_ComplaintsComponent, {
  //       panelClass: "full-width-dialog",
  //       maxWidth: "90vw",
  //       maxHeight: "90%",
  //       width: "90%",
  //       data: {
  //         isheader: true,
  //         disableClose: true,
  //       },
  //     });
  //     dialogRef
  //       .afterClosed()
  //       .pipe(takeUntil(this.destroypresent$))
  //       .subscribe((result) => {
  //         this.get_complaints_PE();
  //         if (this.complaint_dataApicall) {
  //           this.complaint_dataApicall();
  //         }
  //       });
  //   } else {
  //     this.dashboardService.openSnackBar("Add permission denied", "OK");
  //   }
  // }

  presentComplaintscomp() {
    if (
      this.emrservice.PresentingComplaintsPermission?.isAddPermission == true
    ) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(Present_ComplaintsComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "90vw",
        maxHeight: "70%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroypresent$))
        .subscribe((result) => {
          this.get_complaints_PE();
          if (this.complaint_dataApicall) {
            this.complaint_dataApicall();
          }
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  //  --------- DocterWorkup pop_up module call --------

  medicinecomp() {
    if (this.emrservice.medicinePermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(MedicineComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "90vw",
        maxHeight: "70%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroymedicine$))
        .subscribe((result) => {
          this.emrservice.GetFindingGResultByregidd(
            this.opdvisitService.patientdetails.pkRegId,
            this.opdvisitService.visitid,
            this.opdvisitService.DoctorIdEmr,
            0
          );
          this.emrservice
            .GetPrescriptionDetailByRegId(
              this.opdvisitService.patientdetails.pkRegId,
              this.opdvisitService.visitid,
              this.opdvisitService.DoctorIdEmr
            )
            .pipe(takeUntil(this.destroymedicine$))
            .subscribe((data) => {
              this.medicinedata = data;
            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            });
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  diagnosiscomp() {
    if (this.emrservice.diagnosisPermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(DoctorDiagnosisComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "90vw",
        maxHeight: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroydia$))
        .subscribe((result) => {
          this.emrservice.GetFindingGResultByregidd(
            this.opdvisitService.patientdetails.pkRegId,
            this.opdvisitService.visitid,
            this.opdvisitService.DoctorIdEmr,
            0
          );
          this.emrservice
            .getDaigonosisbyRegid(
              this.opdvisitService.patientdetails.pkRegId,
              this.opdvisitService.visitid,
              this.opdvisitService.DoctorIdEmr
            )
            .pipe(takeUntil(this.destroydia$))
            .subscribe((item) => {
              this.drdaignosisdata = item;
              console.log(this.drdaignosisdata, "called dignosis");
            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            });
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  // addDisabledbox(value) {
  //   this.boxDisabled = value;
  //   this.emrservice.setAddNearValue({
  //     boxValue: this.boxDisabled
  //   });
  // }
  othetinformation() {
    if (this.emrservice.investigationPermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(DoctorOtherInfoComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "90vw",
        maxHeight: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroyinves$))
        .subscribe((result) => {
          this.GetFindingGResultByregid(
            this.opdvisitService.patientdetails.pkRegId
          );

          // this.emrservice.GetFindingGResultByregidd(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr, 0);
          // this.emrservice.GetInvestigationDetailByRegId(this.opdvisitService.patientdetails.pkRegId, this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroyinves$)).subscribe(
          //   data => {
          //     this.investigationdata = data;
          //   }
          // )
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  ChangeGvp(type) {
    this.emrservice.enabledisablebtnInfo = false;
    if (type == false) {
      this.opdvisitService.patientDrdetaill[0].isUnderGVP = false;
    } else {
      this.opdvisitService.patientDrdetaill[0].isUnderGVP = true;
    }
  }
  refferchange(event) {
    this.emrservice.enabledisablebtnInfo = false;
    this.opdvisitService.patientDrdetaill[0].isReferredTo = event.checked;
  }

  Investigation() {
    if (this.emrservice.investigationPermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(InvestigationComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "90vw",
        maxHeight: "70%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroyinves$))
        .subscribe((result) => {
          this.emrservice.GetFindingGResultByregidd(
            this.opdvisitService.patientdetails.pkRegId,
            this.opdvisitService.visitid,
            this.opdvisitService.DoctorIdEmr,
            0
          );
          this.emrservice
            .GetInvestigationDetailByRegId(
              this.opdvisitService.patientdetails.pkRegId,
              this.opdvisitService.visitid,
              this.opdvisitService.DoctorIdEmr
            )
            .pipe(takeUntil(this.destroyinves$))
            .subscribe((data) => {
              this.investigationdata = data;
            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            });
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  examinationcompdata() {
    if (this.emrservice.findingPermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(FindingExaminationComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "85vw",
        maxHeight: "70%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroymedicine$))
        .subscribe((result) => {
          this.emrservice.GetFindingGResultByregidd(
            this.opdvisitService.patientdetails.pkRegId,
            this.opdvisitService.visitid,
            this.opdvisitService.DoctorIdEmr,
            0
          );
          this.GetFindingGResultByregid(
            this.opdvisitService.patientdetails.pkRegId
          );
          this.emrservice
            .GetFindingByRegId(
              this.opdvisitService.patientdetails.pkRegId,
              this.opdvisitService.visitid,
              this.opdvisitService.DoctorIdEmr
            )
            .pipe(takeUntil(this.destroyfinding$))
            .subscribe((data) => {
              this.examination_data = data;
              console.log(this.examination_data, "called examination data");
            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            });
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  drSurgerycomp() {
    if (this.emrservice.surgeryPermission?.isAddPermission == true) {
      this.showmodeal = false;
      const dialogRef = this.dialog.open(SurgeryComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "85vw",
        maxHeight: "70%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroysurgery$))
        .subscribe((result) => {
          this.emrservice.GetFindingGResultByregidd(
            this.opdvisitService.patientdetails.pkRegId,
            this.opdvisitService.visitid,
            this.opdvisitService.DoctorIdEmr,
            0
          );
          this.GetFindingGResultByregid(
            this.opdvisitService.patientdetails.pkRegId
          );
          this.emrservice
            .GetSurgeryDetailByRegId(
              this.opdvisitService.patientdetails.pkRegId,
              this.emrservice.visitid,
              this.opdvisitService.DoctorIdEmr
            )
            .pipe(takeUntil(this.destroysurgery$))
            .subscribe((data) => {
              this.surgery_data = data;
            }, err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              }
              else if (err.error.statusCode == 422) {
                this.dashboardService.openSnackBar(err.error.message, "OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            });
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  reviewComp() {
    if (this.emrservice.investigationPermission?.isAddPermission == true) {
      const dialogRef = this.dialog.open(DoctorReviewComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "95vw",
        width: "70%",
        maxHeight: "70%",
        data: {
          isheader: true,
          disableClose: true,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroyreview$))
        .subscribe((result) => {
          this.GetFindingGResultByregid(
            this.opdvisitService.patientdetails.pkRegId
          );
        });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }

  selectDrrow(row, index: any) {

    this.dashboardService.selectedRowIndex = index;
    this.emrservice.visitid = row.fK_VisitId;
    this.emrservice.examid = row.pK_ExamId;
    this.opdvisitService.visitid = row.fK_VisitId;
    this.emrservice.visitDate = row.visitDate;
    if (this.emrservice.pasthistoryPermission?.webIsMenu == true || this.emrservice.surgicalhistoryPermission?.webIsMenu == true) {
      this.historyforjoinvistid(this.opdvisitService.visitid);
      this.emrservice.getHistoryStatus(this.opdvisitService.visitid);
    }
    if (row.doctorId != null) {
      this.opdvisitService.DoctorIdEmr = row.doctorId;
    }
    if (this.emrservice.examid != null && this.emrservice.examid > 0) {
      this.GetFitnessCheckUpDetail();
      if (
        this.emrservice.doctorPermission?.webIsMenu == true &&
        this.emrservice.doctorPermission?.pk_WebMenuUserPermissionDetailId !=
        null
      ) {
        this.emrservice.GetFindingGResultByregidd(
          this.opdvisitService.patientdetails.pkRegId,
          this.opdvisitService.visitid,
          this.opdvisitService.DoctorIdEmr,
          1
        );
        this.emrservice.drWorkupExamStatus(
          this.emrservice.visitid,
          this.emrservice.examid != null ? this.emrservice.examid : 0
        );
      }
      if (
        this.emrservice.primaryExamPermission?.webIsMenu == true &&
        this.emrservice.primaryExamPermission
          ?.pk_WebMenuUserPermissionDetailId != null
      ) {
        this.emrservice.getPExamStatus();
        this.get_opto_data();
        this.get_complaints_PE();
        this.call_DrWorkUp_GroupApi();
        this.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId);
        this.getIOPDetailsbyRegId();
        this.get_IOP_PE();
        this.getAutoRef();
        this.getCurrentMedication();
      }
      if (
        (this.emrservice.primaryExamPermission?.webIsMenu == true &&
          this.emrservice.primaryExamPermission
            ?.pk_WebMenuUserPermissionDetailId != null) ||
        (this.emrservice.counselorPermission?.webIsMenu == true &&
          this.emrservice.counselorPermission
            ?.pk_WebMenuUserPermissionDetailId != null)
      ) {
        this.emrservice.getPExamStatus();
      }
      this.emrservice.content.next("3");
    } else {
      this.emrservice
        .getCareVisit(row.fK_VisitId, this.opdvisitService.DoctorIdEmr)
        .pipe(takeUntil(this.destroyemr$))
        .subscribe((x: any) => {
          this.emrservice.visitid = x[0].fK_VisitId;
          this.opdvisitService.visitid = this.emrservice.visitid;
          this.dashboardService.selectedRowIndex = index;
          let examid = this.opdvisitService.visitdates.filter(
            (item) => item.fK_VisitId == this.emrservice.visitid
          );
          this.emrservice.examid = examid[0].pK_ExamId;
          this.emrservice.visitDate = examid[0].visitDate;
          if (examid[0].doctorId != null && examid[0].doctorId > 0) {
            this.opdvisitService.DoctorIdEmr = examid[0].doctorId;
          } else {
            this.opdvisitService.DoctorIdEmr = examid[0].visitDoctorId;
          }
          this.GetFitnessCheckUpDetail();
          this.emrservice.content.next("3");
          if (
            this.emrservice.primaryExamPermission?.webIsMenu == true &&
            this.emrservice.primaryExamPermission
              ?.pk_WebMenuUserPermissionDetailId != null
          ) {
            this.emrservice.getPExamStatus();
            this.get_opto_data();
            this.get_complaints_PE();
            this.call_DrWorkUp_GroupApi();
            this.GetFindingGResultByregid(this.opdvisitService.patientdetails.pkRegId);
            this.getIOPDetailsbyRegId();
            this.get_IOP_PE();
            this.getAutoRef();
            this.getCurrentMedication();
          }
          if (
            (this.emrservice.primaryExamPermission?.webIsMenu == true &&
              this.emrservice.primaryExamPermission
                ?.pk_WebMenuUserPermissionDetailId != null) ||
            (this.emrservice.counselorPermission?.webIsMenu == true &&
              this.emrservice.counselorPermission
                ?.pk_WebMenuUserPermissionDetailId != null)
          ) {
            this.emrservice.getPExamStatus();
          }
          if (
            this.emrservice.doctorPermission?.webIsMenu == true &&
            this.emrservice.doctorPermission
              ?.pk_WebMenuUserPermissionDetailId != null
          ) {
            this.emrservice.GetFindingGResultByregidd(
              this.opdvisitService.patientdetails.pkRegId,
              this.opdvisitService.visitid,
              this.opdvisitService.DoctorIdEmr,
              1
            );
            this.emrservice.drWorkupExamStatus(
              this.emrservice.visitid,
              this.emrservice.examid != null ? this.emrservice.examid : 0
            );
          }
        }, err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        });
    }

  }

  slectedrow(pkipdid) {
    if (this.emrservice.glassPrescriptionPermission?.isAddPermission == true) {
      const dialogRef = this.dialog.open(InhouseSurgeriesComponent, {
        panelClass: "full-width-dialog",
        maxWidth: "85vw",
        height: "90%",
        width: "90%",
        data: {
          isheader: true,
          disableClose: true,
          pkdta: pkipdid.pK_IPDId,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntil(this.destroyglass$))
        .subscribe((result) => { });
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  cancelDoctorWorkupModal() {
    this.showmodeal = true;
    document.getElementById("doctorWorkupModal").style.display = "none";
  }
  //get current location
  checkenabledisablebtn(visitid) {

    if (
      this.emrservice.enabledisablebtn == false ||
      this.emrservice.enabledisablebtnInv == false ||
      this.emrservice.enabledisablebtnDia == false ||
      this.emrservice.enabledisablebtnMed == false ||
      this.emrservice.enabledisablebtnSur == false ||
      this.emrservice.enabledisablebtnRev == false ||
      this.emrservice.enabledisablebtnInfo == false ||
      this.emrservice.enabledisablebtnpasthistory == false ||
      this.emrservice.enabledisablebtnsurhistory == false
    ) {
      this.checkNavigator(visitid);
    } else {
      this.checklastlocation(visitid);
    }

  }
  closelocation() {
    document.getElementById("MovedToModel").style.display = "none";

  }
  checklastlocation(visitid): void {
    if (visitid > 0) {
      this.showspinner = true;
      this.dashboardService
        .getlastvisittransfer(
          this.opdvisitService.patientdetails.pkRegId,
          visitid
        )
        .pipe(takeUntil(this.destroyglass$))
        .subscribe(
          (item: any) => {
            this.showspinner = false;
            if (item.length > 0) {
              document.getElementById("DCtorSaveModel").style.display = "none";
              this.dashboardService.docterEmr.locationId =
                item[0].fK_PatientLocationId;
              this.dashboardService.docterEmr.isDilated = item[0].isDilated;
              document.getElementById("MovedToModel").style.display = "block";
            }
          },
          (err) => {
            this.showspinner = false;
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            }
            else if (err.error.statusCode == 422) {
              this.dashboardService.openSnackBar(err.error.message, "OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          }
        );
    }
  }
  //move to pateint
  fillusers(usertypeid: number) {
    var pname =
      this.opdvisitService.patientdetails.firstName +
      " " +
      this.opdvisitService.patientdetails.lastName;
    var pid = this.emrservice.visitid;
    if (this.authService.masterdata.isPatientTransfer == true) {
      if (
        this.dashboardService.docterEmr.locationId == usertypeid &&
        usertypeid == 1
      ) {
        return this.dashboardService.openSnackBar(
          "The Patient Is Already At Reception",
          "Ok"
        );
      }
      if (
        this.dashboardService.docterEmr.locationId == usertypeid &&
        usertypeid == 9
      ) {
        return this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg11"],
          this.authService.validationMsg["Ok"]
        );
      }
      if (
        this.dashboardService.docterEmr.locationId == usertypeid &&
        usertypeid == 10
      ) {
        return this.dashboardService.openSnackBar(
          this.authService.validationMsg["dashboardValidMsg.msg12"],
          this.authService.validationMsg["Ok"]
        );
      }
      this.open_loader_Dialog();
      // return
      if (usertypeid == 10) {
        if (this.dashboardService.docterEmr.isDilated != 1) {
          this.return_patient(
            pid,
            this.dashboardService.docterEmr.locationId,
            usertypeid
          );
        } else {
          this.dashboardService.openSnackBar(
            this.authService.validationMsg["dashboardValidMsg.msg13"],
            this.authService.validationMsg["Ok"]
          );
        }
      } else if (usertypeid == 1) {
        this.move_patient_reception(
          pid,
          this.dashboardService.docterEmr.locationId,
          usertypeid
        );
      } else if (usertypeid == 9) {
        this.move_patient_waiting(
          pid,
          this.dashboardService.docterEmr.locationId,
          usertypeid
        );
      } else {
        // this.selectedRowIndex = pid;
        //this.dashboardService.showspinner = true;
        this.dashboardService.pid = pid;
        this.dashboardService.pname = pname;
        this.dashboardService.prelocationid =
          this.dashboardService.docterEmr.locationId;
        this.dashboardService.docterEmr.locationId = usertypeid;
        this.dashboardService.locationid = usertypeid;
        this.get_usertype_list(usertypeid);
      }
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg14"],
        this.authService.validationMsg["Ok"]
      );
    }
  }
  get_usertype_list(usertypeid: number) {
    //
    if (usertypeid == 6) {
      this.dashboardService
        .getall_doctors()
        .pipe(takeUntil(this.destroyfinding$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 5) {
      this.dashboardService
        .getall_ops()
        .pipe(takeUntil(this.destroyfinding$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 4) {
      this.dashboardService
        .getall_ars()
        .pipe(takeUntil(this.destroyfinding$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 3) {
      this.dashboardService
        .getall_cds()
        .pipe(takeUntil(this.destroyfinding$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 7) {
      this.dashboardService
        .getall_css()
        .pipe(takeUntil(this.destroyfinding$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    } else if (usertypeid == 8) {
      this.dashboardService
        .getall_prs()
        .pipe(takeUntil(this.destroyfinding$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    }
    // physician
    else if (usertypeid == 23) {
      this.dashboardService
        .getall_physicians()
        .pipe(takeUntil(this.destroyfinding$))
        .subscribe(
          (data) => this.success_usertype_list(data),
          (err) => this.failed_usertype_list(err)
        );
    }
  }
  success_usertype_list(data) {
    this.dashboardService.usertype_list = data;
    this.dialog.closeAll();
    this.getusertype();
    this.openDialog();

  }
  failed_usertype_list(err) {
    this.dashboardService.pid = null;
    this.dashboardService.pname = null;
    this.dashboardService.locationid = null;
    this.dashboardService.prelocationid = null;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  getusertype() {
    switch (this.dashboardService.locationid) {
      case 3: {
        this.dashboardService.usertypestring = "CD(S)";
        break;
      }
      case 4: {
        this.dashboardService.usertypestring = "AR(S)";
        break;
      }
      case 5: {
        this.dashboardService.usertypestring = "OP(S)";
        break;
      }
      case 6: {
        this.dashboardService.usertypestring = "DOCTOR(S)";
        break;
      }
      case 7: {
        this.dashboardService.usertypestring = "CS(S)";
        break;
      }
      case 8: {
        this.dashboardService.usertypestring = "PR(S)";
        break;
      }
      case 23: {
        this.dashboardService.usertypestring = "PHY(S)";
        break;
      }
    }
  }

  openWaitingDialog(visitid: number): void {
    const dialogRef = this.dialog.open(WaitingReasonComponent, {
      panelClass: "full-width-dialog",

      height: "30%",
      width: "40%",
      data: {
        // remark: remark,
        visitid: visitid,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyfinding$))
      .subscribe((result) => {
        this.dialog.closeAll();
        if (this.dashboardService.waitingreason == true) {
          // this.closetrasnferdata();
          this.movetodashboard();
          // this.ChangeCallStatus(this.callstausModelobj,this.authService.Loggeduser.room,'TRANSFER');
        }

        //pid = result;
      });
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(PatientMoveDialogComponent, {
      width: "800px",
      data: {
        name: this.dashboardService.pname,
        id: this.dashboardService.pid,
        usertypeid: this.dashboardService.locationid,
        userid: this.authService.Loggeduser.userid,
        prelocationid: this.dashboardService.prelocationid,
        usertype: this.dashboardService.usertypestring,
        patientInfo: this.dashboardService.docterEmr,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyfinding$))
      .subscribe((result) => {
        this.dialog.closeAll();
        if (this.dashboardService.popup_cancel != true) {
          // this.closetrasnferdata();
          if (result != "0" && result != null) {

            this.ChangeCallStatus(this.callstausModelobj, result.roomName, result.loginroomId, "TRANSFER");
            this.movetodashboard();
          }
        }


        //pid = result;
      });
  }
  move_patient_waiting(
    visitid: number,
    prelocationid: number,
    currentloc: any
  ) {
    this.openWaitingDialog(visitid);
  }
  return_patient(visitid: number, prelocationid: number, currentloc: any) {
    this.dashboardService
      .getlocationType(
        visitid,
        this.authService.Loggeduser.userid,
        0,
        this.authService.Loggeduser.branchid,
        prelocationid,
        currentloc,
        0
      )
      .pipe(takeUntil(this.destroyfinding$))
      .subscribe(
        (data) => this.success_patient_moved(data),
        (err) => this.failed_patient_moved(err)
      );
  }
  success_patient_moved(data) {
    //this.closetrasnferdata();
    this.dashboardService.openSnackBar(
      this.authService.validationMsg["dashboardValidMsg.msg15"],
      this.authService.validationMsg["Ok"]
    );
    this.ChangeCallStatus(
      this.callstausModelobj,
      this.authService.Loggeduser.room,
      this.authService.Loggeduser.roomid,
      "RETURN"
    );
    this.movetodashboard();
  }
  failed_patient_moved(err) {
    this.closelocation();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg16"],
        this.authService.validationMsg["Ok"]
      );
    }
    this.refresh_opd_visits();
  }
  move_patient_reception(
    visitid: number,
    prelocationid: number,
    currentloc: any
  ) {
    this.dashboardService
      .getlocationType(
        visitid,
        this.authService.Loggeduser.userid,
        0,
        this.authService.Loggeduser.branchid,
        prelocationid,
        currentloc,
        0
      )
      .pipe(takeUntil(this.destroyfinding$))
      .subscribe(
        (data) => this.success_patient_moved_reception(data),
        (err) => this.failed_patient_moved_reception(err)
      );
  }
  success_patient_moved_reception(data) {
    // this.closetrasnferdata();
    this.dashboardService.openSnackBar(
      this.authService.validationMsg["dashboardValidMsg.msg17"],
      this.authService.validationMsg["Ok"]
    );
    this.ChangeCallStatus(
      this.callstausModelobj,
      this.authService.Loggeduser.room,
      this.authService.Loggeduser.roomid,
      "TRANSFER"
    );
    this.movetodashboard();
  }
  failed_patient_moved_reception(err) {
    this.closelocation();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg16"],
        this.authService.validationMsg["Ok"]
      );
      // this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }


  refresh_opd_visits() {
    this.dashboardService.selecteddate = this.datepipe.transform(
      this.dashboardService.todaysdate,
      "yyyy-MM-dd"
    );

    this.dashboardService
      .getopdvisit()
      .pipe(takeUntil(this.destroyfinding$))
      .subscribe(
        (data) => this.successopdvisit(data),
        (err) => this.failedopdvisit(err)
      );
  }
  successopdvisit(data) {
    this.authService.storevisitdata = of(data);
  }

  failedopdvisit(err) {
    //this.dialog.closeAll();
    this.dashboardService.showspinner = false;
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  movetodashboard() {

    this.emrservice.enabledisablebtn = null;
    this.emrservice.enabledisablebtnInv = null;
    this.emrservice.enabledisablebtnDia = null;
    this.emrservice.enabledisablebtnMed = null;
    this.emrservice.enabledisablebtnSur = null;
    this.emrservice.enabledisablebtnRev = null;
    this.emrservice.enabledisablebtnInfo = null;
    this.emrservice.enabledisablebtnpasthistory = null;
    this.emrservice.enabledisablebtnsurhistory = null;
    // document.getElementById("DCtorSaveModel").style.display = "none";
    document.getElementById("MovedToModel").style.display = "none";
    this.router.navigate(["/layout/dashboard"]);
  }
  open_loader_Dialog(): void {
    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: "300px",
      panelClass: "site-loader",
      data: {},
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.destroyfinding$))
      .subscribe((result) => { });

    setInterval(() => {
      dialogRef.close();
    }, 1250);
  }

  readMoreModal(field, header) {
    this.selectedField = field;
    this.selectedHeader = header;
    document.getElementById("readMoreModal").style.display = "block";
    document.getElementById("readMoreModal").style.display = "block";
  }
  closedReadMoreModal() {
    document.getElementById("readMoreModal").style.display = "none";
  }
  //autocomplet
  doctorControll() {
    this.emrDoctorCtrl = new FormControl();
    this.filteredDoctorArray = this.emrDoctorCtrl.valueChanges.pipe(
      startWith(""),
      map((cat) =>
        cat
          ? this.filterdoctorfunction(cat)
          : this.opdvisitService.doctors.slice()
      )
    );
  }

  filterdoctorfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.opdvisitService.doctors.filter(
      (country) => country.userName?.toLowerCase().indexOf(filterValue) === 0
    );
  }

  CheckinputDoctor(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.doctorControll();
    }
  }
  ngOnDestroy(): void {
    console.log("emr destroy");
    this.destroyemr$.next(true);
    this.destroyemr$.unsubscribe();
    this.destroymedicine$.next(true);
    this.destroymedicine$.unsubscribe();
    this.destroydia$.next(true);
    this.destroydia$.unsubscribe();
    this.destroypresent$.next(true);
    this.destroypresent$.unsubscribe();
    this.destroypast$.next(true);
    this.destroypast$.unsubscribe();
    this.destroysugical$.next(true);
    this.destroysugical$.unsubscribe();
    this.destroydrug$.next(true);
    this.destroydrug$.unsubscribe();
    this.destroyfinding$.next(true);
    this.destroyfinding$.unsubscribe();
    this.destroysurgery$.next(true);
    this.destroysurgery$.unsubscribe();
    this.destroyglass$.next(true);
    this.destroyglass$.unsubscribe();
    this.destroyvision$.next(true);
    this.destroyvision$.unsubscribe();
    this.destroyinves$.next(true);
    this.destroyinves$.unsubscribe();
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    this.QMYN = null;
    this.callstausModelobj = null;
    this.past_history = null;
    this.sergi_history = null;
    this.drug_data = null;
    this.advisedName = null;
    this.boxDisabled = null;
    this.medicinedata = null;
    this.drdaignosisdata = null;
    this.investigationdata = null;
    this.examination_data = null;
    this.examdetailArray = null;
    this.surgery_data = null;
    this.inhouse_data = null;
    this.datalist = null;
    this.filterQuery = null;
    this.filteredDataa = null;
    this.showmodeal = null;
    this.emrservice.otherinfo_history = null;
    this.FitnessCheckupData = {};
    this.ApprovalStatuslist = null;
    this.dataSource.data = null;
    this.diagnosislist = null;
    this.investigationDetaillist = null;
    this.prescriptionDetaillist = null;
    this.optoList = null;
    this.otsurgrylist = null;
    this.iopdetailslist = null;
    this.groupedFindingData = null;
    this.emrservice.selectedInvestigationRow = null;
    this.emrservice.holdtimeAutoref = null;
    this.emrservice.holdtimeopto = null;
    this.emrservice.holdtimeDoctor = null;
    this.emrservice.holdtimeCounselor = null;
    this.emrservice.holdtimeprocedure = null;
    this.emrservice.ar_value_box = null;
    this.emrservice.keratometer_value_box = null;
    this.emrservice.eyechkcategory = null;
    this.emrservice.counselorExamModel = null;
    this.emrservice.branchmansterObj = null;
    this.emrservice.autoref = null;
    this.emrservice.pasthistory = null;
    this.emrservice.medinicationMainArray = null;
    this.emrservice.drugAllergydata = "";
    this.emrservice.sitelist = null;
    this.emrservice.opto = null;
    this.emrservice.optohelplist = null;
    this.emrservice.localStorePriscription = null;
    this.emrservice.drWorkupStatus = null;
    this.emrservice.fontFamilies = null;
    this.emrservice.historyPermission = null;
    this.emrservice.pasthistoryPermission = null;
    this.emrservice.surgicalhistoryPermission = null;
    this.emrservice.familyhistoryPermission = null;
    this.emrservice.drughistoryPermission = null;
    this.emrservice.socialhistoryPermission = null;
    this.emrservice.otherhistoryPermission = null;
    this.emrservice.primaryExamPermission = null;
    this.emrservice.PresentingComplaintsPermission = null;
    this.emrservice.autorefkeroPermission = null;
    this.emrservice.intraocularPressurePermission = null;
    this.emrservice.oldGlassPermission = null;
    this.emrservice.visionPermission = null;
    this.emrservice.currentMPermission = null;
    this.emrservice.unDilatedAndDilatedPermission = null;
    this.emrservice.glassPrescriptionPermission = null;
    this.emrservice.optometristPermission = null;
    this.emrservice.optoSliptLampPermission = null;
    this.emrservice.advisedInvestigationsPermission = null;
    this.emrservice.postOpInformationPermission = null;
    this.emrservice.doctorPermission = null;
    this.emrservice.findingPermission = null;
    this.emrservice.investigationPermission = null;
    this.emrservice.diagnosisPermission = null;
    this.emrservice.medicinePermission = null;
    this.emrservice.surgeryPermission = null;
    this.emrservice.reviewPermission = null;
    this.emrservice.otherInformationPermission = null;
    this.emrservice.counselorPermission = null;
    this.emrservice.procedurePermission = null;
    this.emrservice.drWorkupStatus = null;
    this.emrservice.pExamStatusChk = null;
    this.emrservice.webMenuPermission = null;
    this.emrservice.historyStatusresult = null;
    this.emrservice.sitelist = null;
    this.emrservice.drugallergy_added = null;
    this.emrservice.drugallergy = null;
    this.emrservice.intraocularpressure = null;
    this.emrservice.add_io = null;
    this.emrservice.familyhistory = null;
    this.emrservice.surgicalhistory_client = null;
    this.emrservice.surgicalhistory = null;
    this.emrservice.students_opto = null;
    this.emrservice.students_opto_list = null;
    this.emrservice.medinicationMainArray = null;
    this.emrservice.add_OptoTestDetails = null;
    this.emrservice.presentingcomplaints = null;
    this.emrservice.add_presentingcomplaints = null;
    this.opdvisitService.patientDrdetaill = null;
    this.emrservice.counselorExamModel = null;
    this.emrservice.patientEMRdetail = null;
    this.emrservice.enabledisablepog = null;
    this.emrservice.enabledisableVision = null;
    this.emrservice.enabledisableautorefkr = null;
    this.emrservice.enabledisableautorefkr1 = null;
    this.emrservice.enabledisableUd = null;
    this.emrservice.enabledisableGP = null;
    this.emrservice.enabledisableopt = null;
    this.emrservice.enabledisablebtn = null;
    this.emrservice.enabledisablebtnInv = null;
    this.emrservice.enabledisablebtnDia = null;
    this.emrservice.enabledisablebtnMed = null;
    this.emrservice.enabledisablebtnSur = null;
    this.emrservice.enabledisablebtnRev = null;
    this.emrservice.enabledisablebtnInfo = null;
    this.emrservice.enabledisablebtnpasthistory = null;
    this.emrservice.enabledisablebtnsurhistory = null;
    this.counsellorstatus = null;
    this.procedurestatus = null;
    this.popupcontrolindex = null;
  }


  visibleFindingIndex: number = -1;
  toggleFindingSection(index: number) {
    if (this.visibleFindingIndex === index) {
      this.visibleFindingIndex = -1;
    } else {
      this.visibleFindingIndex = index;
    }
  }
}
